import Vue from "vue";
// import Router from "vue-router";

// 最近修改：2025/2/14，路由修改
// import pageHome from './views/page-home.vue' // 首页
// import pageMemberManage from './views/page-member-manage' //会员管理页
// import pageOrderCare from './views/page-order-care' //订单关怀
Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default new VueRouter({
  mode: "history",
  // mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/redirection",
      name: "redirection",
      component: (resolve) => {
        require(["./views/redirection.vue"], resolve);
      },
    },
    {
      path: "/",
      redirect: "/platformLogin",
    },
    // {
    //   path: "/peopleFilter",
    //   name: "peopleFilter",
    //   component: (resolve) => {
    //     require(["./views/manage/grouping/grouping.vue"], resolve);
    //   },
    // },
    //暂时去除
    // {
    //   path: "/refresh",
    //   name: "refresh",
    //   component: (resolve) => {
    //     require(["./views/refresh.vue"], resolve);
    //   },
    // },
    // {
    //   path: "*",
    //   redirect: '/home'
    // },
    
    //平台板登录页-----------旧登录
    // {
    //     path: '/platformLogin',
    //     name: 'platformLogin',
    //     meta: {
    //       isOther: true, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
    //     },
    //     component: (resolve) => {
    //       require(['./views/home/platform_login'], resolve)
    //     }
    // },



    //----------7.1换成跟抖音云舟一样的登录--------------新，lin
    {
      path: '/platformLogin',
      name: 'platformLogin',
      meta: {
        isOther: true, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      },
      component: (resolve) => {
        require(['./views/home/platform_login1'], resolve)
      }
    },
    // 云舟首页
    {
      path: "/home",
      name: "home",
      component: (resolve) => {
        require(["./views/home/page_home_new.vue"], resolve);
      },
    },
    // 京获客旗舰版首页
     {
      path: "/hdHome",
      name: "jhkHome",
      component: (resolve) => {
        require(["./views/home/jhk_page_home.vue"], resolve);
      },
    },
    // 互动营销
    {
      path: "/interactive",
      name: "interactive",
      component: (resolve) => {
        require(["./views/interactive/index.vue"], resolve);
      },
    },
    {
      path: "/prizeCenter", //积分授权页面
      name: "prizeCenter",
      component: (resolve) => {
        require(["./views/integralCenter/prizeCenter.vue"], resolve);
      },
    },
    {
      path: "/prizeCenter2", //积分授权页面
      name: "prizeCenter2",
      component: (resolve) => {
        require(["./views/integralCenter/prizeCenter2.vue"], resolve);
      },
    },
    // {
    //   path: "/login",
    //   name: "home",
    //   component: (resolve) => {
    //     require(["./views/login/login.vue"], resolve);
    //   },
    // },
    {
      path: "/manage",
      component: (resolve) => {
        require(["./views/router_page.vue"], resolve);
      },
      children: [
        {
          path: "",
          redirect: { name: "focusShop" },
        },
        {
          path: "share_polite",
          name: "share_polite",
          component: (resolve) => {
            require(["./views/manage/share_polite.vue"], resolve);
          },
        },
        //人群管理
        {
          path: "crowd_management",
          name: "crowd_management",
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "recommend_crowd",
              name: "人群推荐",
              component: (resolve) => {
                require(["./views/manage/grouping/recommend_crowd.vue"], resolve);
              },
            },
            {
              path: "offical_recommend_crowd",
              name: "官方推荐",
              component: (resolve) => {
                require(["./views/manage/grouping/office_crowd.vue"], resolve);
              },
            },
            {
              path: "JD_crowd",
              name: "JD_crowd",
              component: (resolve) => {
                require(["./views/manage/grouping/grouping.vue"], resolve);
              },
            },
            {
              path: "/peopleFilter",
              name: "peopleFilter",
              component: (resolve) => {
                require(["./views/manage/grouping/peopleFilter.vue"], resolve);
              },
            },
            {
              path: "yeion_crowd",
              name: "云起人群",
              component: (resolve) => {
                require(["./views/manage/grouping/yeion_crowd.vue"], resolve);
              },
            },
            {
              path: "clac_crowd",
              name: "人群运算",
              component: (resolve) => {
                require(["./views/manage/grouping/clac_crowd.vue"], resolve);
              },
            },
          ],
        },
        {
          path: "manage",
          redirect: { name: "focusShop" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "focusShop" },
            },
            {
              path: "focusShop",
              name: "focusShop",
              component: (resolve) => {
                require(["./views/manage/focusShop.vue"], resolve);
              },
            },
            {
              path: "focus_merchandise",
              name: "focus_merchandise",
              component: (resolve) => {
                require(["./views/manage/focus_merchandise.vue"], resolve);
              },
            },
            {
              path: "grouping",
              name: "grouping",
              component: (resolve) => {
                require(["./views/manage/grouping.vue"], resolve);
              },
            },
            {
              path: "labelManage",
              name: "labelManage",
              component: (resolve) => {
                require(["./views/manage/labelManageMain/index.vue"], resolve);
              },
            },
          ],
        },
        // 用户-会员列表
        {
          path: "mutualMember",
          name: "mutualMember",
          component: (resolve) => {
            require(["./views/member/mutualMember.vue"], resolve);
          },
          meta: {
            title: "会员列表",
          },
        },
        // 用户-云起人群
        {
          path: "yeion_crowd",
          name: "云起人群",
          component: (resolve) => {
            require(["./views/manage/grouping/yeion_crowd.vue"], resolve);
          },
          meta: {
            title: "云起人群",
          },
        },
        // {
        //   path: "member",
        //   redirect: { name: "mutualMember" },
        //   component: (resolve) => {
        //     require(["./views/router_page1.vue"], resolve);
        //   },
        //   children: [
        //     {
        //       path: "",
        //       redirect: { name: "mutualMember" },
        //     },
        //     {
        //       path: "mutualMember",
        //       name: "mutualMember",
        //       component: (resolve) => {
        //         require(["./views/member/mutualMember.vue"], resolve);
        //       },
        //     },
        //     {
        //       path: "memberLevel",
        //       name: "memberLevel",
        //       component: (resolve) => {
        //         require(["./views/member/memberLevel.vue"], resolve);
        //       },
        //     },
        //     {
        //       path: "batchDistributionBenefits",
        //       name: "batchDistributionBenefits",
        //       component: (resolve) => {
        //         require(["./views/member/batchDistributionBenefits.vue"], resolve);
        //       },
        //     },
        //     {
        //       path: "pointsManagement",
        //       name: "pointsManagement",
        //       component: (resolve) => {
        //         require(["./views/member/pointsManagement.vue"], resolve);
        //       },
        //     },
        //     {
        //       path: "channel",
        //       name: "channel",
        //       component: (resolve) => {
        //         require(["./views/member/channel.vue"], resolve);
        //       },
        //     },
        //     {
        //       path: "shopDecoration",
        //       name: "shopDecoration",
        //       component: (resolve) => {
        //         require(["./views/member/shopDecoration.vue"], resolve);
        //       },
        //     },
        //   ],
        // },
        // 标签管理
        {
          path: "labelManage",
          redirect: { name: "labelManage" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "labelManage" },
            },
            {
              path: "labelManage",
              name: "labelManage",
              component: (resolve) => {
                require(["./views/manage/label_manage.vue"], resolve);
              },
            },
            {
              path: "automatic_marking",
              name: "automatic_marking",
              component: (resolve) => {
                require(["./views/manage/automatic_marking.vue"], resolve);
              },
            },
          ],
        },
      ],
    },

    // 会员关怀
    {
      path: "/orderCare",
      component: (resolve) => {
        require(["./views/router_page.vue"], resolve);
      },

      children: [
        // 下单催付
        {
          path: "",
          redirect: { name: "expediting" },
        },
        //订单实时监控，平台版添加
        {
          path: "orderMonitor",
          name: "orderMonitor",
          component: (resolve) => {
            require(["./views/care/order-monitor.vue"], resolve);
          },
          meta: {
            desc: "订单监控",
          }
        },
        {
          path: "orderCare",
          redirect: { name: "expediting" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "expediting" },
            },
            {
              path: "goodsOrderCare",
              name: "goodsOrderCare",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },

              meta: {
                isOfficial: true,
                officialType: 4,
                smsLabel: [
                  "#商品名称#",
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                  "#邮费#",
                ],
              },
            },
            //end
            {
              path: "expediting",
              name: "expediting",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 1,
                smsLabel: [
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#催付链接#",
                ],
              },
            },
            {
              path: "twiceExpediting",
              name: "twiceExpediting",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 1,
                smsLabel: [
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#催付链接#",
                ],
              },
            },
            {
              path: "presaleExpediting",
              name: "presaleExpediting",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 2, //查询官方模板所需ID
                smsLabel: [],
              },
            },
            {
              path: "payReminder",
              name: "payReminder",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 3,
                smsLabel: [
                  "#商品名称#",
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                ],
              },
            },
            //取消提醒
            {
              path: "cancelMind",
              name: "cancelMind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 9,
                smsLabel: [
                  "#商品名称#",
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                  "#快递单号#",
                  "#快递公司名称#",
                  "#到达地区#",
                ],
              },
            },
            {
              path: "cancelMind",
              name: "cancelMind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 9,
                smsLabel: [
                  "#商品名称#",
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                  "#快递单号#",
                  "#快递公司名称#",
                  "#到达地区#",
                ],
              },
            },
            {
              path: "sendreMind",
              name: "sendreMind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 10,
                smsLabel: [
                  "#商品名称#",
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                  "#快递单号#",
                  "#快递公司名称#",
                  "#到达地区#",
                  "#商家备注#",
                ],
              },
            },
            {
              path: "delayMind",
              name: "delayMind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 11,
                smsLabel: [
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                  "#到达地区#",
                ],
              },
            },
            {
              path: "delivereMind",
              name: "delivereMind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 12,
                smsLabel: [
                  "#商品名称#",
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                  "#快递单号#",
                  "#快递公司名称#",
                  "#到达地区#",
                ],
              },
            },
            {
              path: "recvreMind",
              name: "recvreMind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 13,
                smsLabel: [
                  "#商品名称#",
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                  "#快递单号#",
                  "#快递公司名称#",
                  "#到达地区#",
                ],
              },
            },
            {
              path: "goodsBackMind",
              name: "goodsBackMind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 14,
                smsLabel: [
                  "#商品名称#",
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                  "#快递单号#",
                  "#快递公司名称#",
                  "#到达地区#",
                ],
              },
            },
            {
              tittle: "回款关怀",
              path: "moneyBack",
              name: "moneyBack",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 15,
                smsLabel: [
                  "#商品名称#",
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                  "#快递单号#",
                  "#快递公司名称#",
                  "#到达地区#",
                  "#商家备注#",
                ],
              },
            },
            {
              path: "evaluate",
              name: "evaluate",
              component: (resolve) => {
                require(["./views/care/evaluate.vue"], resolve);
              },
            },
            {
              path: "manualurg",
              name: "manualurg",
              component: (resolve) => {
                require(["./views/serviceCenter/manualurg.vue"], resolve);
              },
            },
            {
              tittle: "自动催评",
              path: "autoEvaluation",
              name: "autoEvaluation",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 5,
                smsLabel: [
                  "#买家昵称#",
                  "#收货人姓名#",
                  "#订单号#",
                  "#下单时间#",
                  "#评价链接#",
                ],
              },
            },
            {
              tittle: "好评感谢",
              path: "thankEvaluation",
              name: "thankEvaluation",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 6,
                smsLabel: [
                  "#买家昵称#",
                  "#收货人姓名#",
                  "#订单号#",
                  "#下单时间#",
                  "#评价链接#",
                ],
              },
            },
            {
              tittle: "中差评安抚",
              path: "poorEvaluation",
              name: "poorEvaluation",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 7,
                smsLabel: [
                  "#买家昵称#",
                  "#收货人姓名#",
                  "#订单号#",
                  "#下单时间#",
                  "#评价链接#",
                ],
              },
            },
            {
              tittle: "好评感谢（自营）",
              path: "thankEvaluationOfficial",
              name: "thankEvaluationOfficial",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 6, //查询官方模板所需ID
                smsLabel: [
                  "#买家昵称#",
                  "#收货人姓名#",
                  "#订单号#",
                  "#下单时间#",
                  "#评价链接#",
                ],
              },
            },
            {
              tittle: "中差评安抚（自营）",
              path: "poorEvaluationOfficial",
              name: "poorEvaluationOfficial",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 7, //查询官方模板所需ID
                smsLabel: [
                  "#买家昵称#",
                  "#收货人姓名#",
                  "#订单号#",
                  "#下单时间#",
                  "#评价链接#",
                ],
              },
            },
            {
              tittle: "退款处理",
              path: "refundCenter",
              name: "refundCenter",
              component: (resolve) => {
                require(["./views/care/refundCenter.vue"], resolve);
              }
            },
            {
              tittle: "申请退款",
              path: "apply",
              name: "apply",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 16,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#售后链接#",
                ],
              },
            },
            {
              tittle: "同意退款",
              path: "agree",
              name: "agree",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 17,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#审核退款结果#",
                  "#售后链接#",
                ],
              },
            },
            {
              tittle: "拒绝退款",
              path: "deny",
              name: "deny",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 18,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#审核退款结果#",
                  "#售后链接#",
                ],
              },
            },
            {
              tittle: "退款成功",
              path: "suces",
              name: "suces",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 19,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#审核退款结果#",
                  "#售后链接#",
                ],
              },
            },
            {
              path: "goodsBackMind",
              name: "goodsBackMind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 11,
                smsLabel: [
                  "#商品名称#",
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                  "#快递单号#",
                  "#快递公司名称#",
                  "#到达地区#",
                ],
              },
            },
            {
              path: "commentWarning",
              name: "commentWarning",
              component: (resolve) => {
                require(["./views/serviceCenter/commentWarning.vue"], resolve);
              }
            },
            {
              path: "refundWarning",
              name: "refundWarning",
              component: (resolve) => {
                require(["./views/serviceCenter/refundWarning.vue"], resolve);
              }
            },
            {
              tittle: "入会关怀",
              path: "openCardRemind",
              name: "openCardRemind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 20,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#售后链接#",
                ],
              },
            },
            {
              tittle: "升级有礼",
              path: "upgradeGift",
              name: "upgradeGift",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 21,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#审核退款结果#",
                  "#售后链接#",
                ],
              },
            },
            {
              tittle: "降级关怀",
              path: "degradeRemind",
              name: "degradeRemind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 22,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#审核退款结果#",
                  "#售后链接#",
                ],
              },
            },
            {
              tittle: "退会挽回",
              path: "closeCardRemind",
              name: "closeCardRemind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 23,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#审核退款结果#",
                  "#售后链接#",
                ],
              },
            },
            {
              tittle: "积分变更通知",
              path: "pointChangeRemind",
              name: "pointChangeRemind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 24,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#审核退款结果#",
                  "#售后链接#",
                ],
              },
            },
            {
              tittle: "即将升级提醒",
              path: "willUp",
              name: "willUp",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 25,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#审核退款结果#",
                  "#售后链接#",
                ],
              },
            },
          ],
        },
        // 付款关怀
        {
          path: "payReminder",
          redirect: { name: "payReminder" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "payReminder",
              name: "payReminder",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 3,
                smsLabel: [
                  "#商品名称#",
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                ],
              },
            },
            //取消提醒
            {
              path: "cancelMind",
              name: "cancelMind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 9,
                smsLabel: [
                  "#商品名称#",
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                  "#快递单号#",
                  "#快递公司名称#",
                  "#到达地区#",
                ],
              },
            },

          ],
        },
        // 物流提醒
        {
          path: "transreMind",
          redirect: { name: "transreMind" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "cancelMind",
              name: "cancelMind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 9,
                smsLabel: [
                  "#商品名称#",
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                  "#快递单号#",
                  "#快递公司名称#",
                  "#到达地区#",
                ],
              },
            },
            {
              path: "sendreMind",
              name: "sendreMind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 10,
                smsLabel: [
                  "#商品名称#",
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                  "#快递单号#",
                  "#快递公司名称#",
                  "#到达地区#",
                  "#商家备注#",
                ],
              },
            },
            {
              path: "delayMind",
              name: "delayMind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 11,
                smsLabel: [
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                  "#到达地区#",
                ],
              },
            },
            {
              path: "delivereMind",
              name: "delivereMind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 12,
                smsLabel: [
                  "#商品名称#",
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                  "#快递单号#",
                  "#快递公司名称#",
                  "#到达地区#",
                ],
              },
            },
            {
              path: "recvreMind",
              name: "recvreMind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 13,
                smsLabel: [
                  "#商品名称#",
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                  "#快递单号#",
                  "#快递公司名称#",
                  "#到达地区#",
                ],
              },
            },
            {
              path: "goodsBackMind",
              name: "goodsBackMind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 14,
                smsLabel: [
                  "#商品名称#",
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                  "#快递单号#",
                  "#快递公司名称#",
                  "#到达地区#",
                ],
              },
            },
          ],
        },
        // 回款关怀
        {
          path: "moneyBack",
          redirect: { name: "moneyBack" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              tittle: "回款关怀",
              path: "moneyBack",
              name: "moneyBack",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 15,
                smsLabel: [
                  "#商品名称#",
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                  "#快递单号#",
                  "#快递公司名称#",
                  "#到达地区#",
                  "#商家备注#",
                ],
              },
            },
          ],
        },
        // 评价关怀
        {
          path: "comtCare",
          redirect: { name: "comtCare" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "evaluate",
              name: "evaluate",
              component: (resolve) => {
                require(["./views/care/evaluate.vue"], resolve);
              },
            },
            {
              path: "manualurg",
              name: "manualurg",
              component: (resolve) => {
                require(["./views/serviceCenter/manualurg.vue"], resolve);
              },
            },
            {
              tittle: "自动催评",
              path: "autoEvaluation",
              name: "autoEvaluation",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 5,
                smsLabel: [
                  "#买家昵称#",
                  "#收货人姓名#",
                  "#订单号#",
                  "#下单时间#",
                  "#评价链接#",
                ],
              },
            },
            {
              tittle: "好评感谢",
              path: "thankEvaluation",
              name: "thankEvaluation",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 6,
                smsLabel: [
                  "#买家昵称#",
                  "#收货人姓名#",
                  "#订单号#",
                  "#下单时间#",
                  "#评价链接#",
                ],
              },
            },
            {
              tittle: "中差评安抚",
              path: "poorEvaluation",
              name: "poorEvaluation",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 7,
                smsLabel: [
                  "#买家昵称#",
                  "#收货人姓名#",
                  "#订单号#",
                  "#下单时间#",
                  "#评价链接#",
                ],
              },
            },
            {
              tittle: "好评感谢（自营）",
              path: "thankEvaluationOfficial",
              name: "thankEvaluationOfficial",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 6, //查询官方模板所需ID
                smsLabel: [
                  "#买家昵称#",
                  "#收货人姓名#",
                  "#订单号#",
                  "#下单时间#",
                  "#评价链接#",
                ],
              },
            },
            {
              tittle: "中差评安抚（自营）",
              path: "poorEvaluationOfficial",
              name: "poorEvaluationOfficial",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 7, //查询官方模板所需ID
                smsLabel: [
                  "#买家昵称#",
                  "#收货人姓名#",
                  "#订单号#",
                  "#下单时间#",
                  "#评价链接#",
                ],
              },
            },
          ],
        },
        // 退款关怀
        {
          path: "refunCare",
          redirect: { name: "refunCare" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              tittle: "退款处理",
              path: "refundCenter",
              name: "refundCenter",
              component: (resolve) => {
                require(["./views/care/refundCenter.vue"], resolve);
              }
            },
            {
              tittle: "申请退款",
              path: "apply",
              name: "apply",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 16,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#售后链接#",
                ],
              },
            },
            {
              tittle: "同意退款",
              path: "agree",
              name: "agree",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 17,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#审核退款结果#",
                  "#售后链接#",
                ],
              },
            },
            {
              tittle: "拒绝退款",
              path: "deny",
              name: "deny",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 18,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#审核退款结果#",
                  "#售后链接#",
                ],
              },
            },
            {
              tittle: "退款成功",
              path: "suces",
              name: "suces",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 19,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#审核退款结果#",
                  "#售后链接#",
                ],
              },
            },
            {
              path: "goodsBackMind",
              name: "goodsBackMind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 11,
                smsLabel: [
                  "#商品名称#",
                  "#订单号#",
                  "#买家姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                  "#快递单号#",
                  "#快递公司名称#",
                  "#到达地区#",
                ],
              },
            },
          ],
        },
        // 店铺预警
        {
          path: "shopWarning",
          redirect: { name: "shopWarning" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "commentWarning",
              name: "commentWarning",
              component: (resolve) => {
                require(["./views/serviceCenter/commentWarning.vue"], resolve);
              }
            },
            {
              path: "refundWarning",
              name: "refundWarning",
              component: (resolve) => {
                require(["./views/serviceCenter/refundWarning.vue"], resolve);
              }
            }
          ],
        },
        // 会员关怀
        {
          path: "memberCare",
          redirect: { name: "memberCare" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              tittle: "入会关怀",
              path: "openCardRemind",
              name: "openCardRemind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 20,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#售后链接#",
                ],
              },
            },
            {
              tittle: "升级有礼",
              path: "upgradeGift",
              name: "upgradeGift",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 21,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#审核退款结果#",
                  "#售后链接#",
                ],
              },
            },
            {
              tittle: "降级关怀",
              path: "degradeRemind",
              name: "degradeRemind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 22,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#审核退款结果#",
                  "#售后链接#",
                ],
              },
            },
            {
              tittle: "退会挽回",
              path: "closeCardRemind",
              name: "closeCardRemind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 23,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#审核退款结果#",
                  "#售后链接#",
                ],
              },
            },
            {
              tittle: "积分变更通知",
              path: "pointChangeRemind",
              name: "pointChangeRemind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 24,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#审核退款结果#",
                  "#售后链接#",
                ],
              },
            },
            {
              tittle: "即将升级提醒",
              path: "willUp",
              name: "willUp",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 25,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#审核退款结果#",
                  "#售后链接#",
                ],
              },
            },
          ],
        },
        // 购物关怀
        {
          path: "shopCare",
          redirect: { name: "shopCare" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              tittle: "智能凑单提醒",
              path: "smartRecommendRemind",
              name: "smartRecommendRemind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 25,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#售后链接#",
                ],
              },
            },
            {
              tittle: "购后入会提醒",
              path: "buyWithNoOpenCardRemind",
              name: "buyWithNoOpenCardRemind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 26,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#审核退款结果#",
                  "#售后链接#",
                ],
              },
            },
            {
              tittle: "直播预售下单关怀",
              path: "shopLivePreSaleOrderRemind",
              name: "shopLivePreSaleOrderRemind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 27,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#审核退款结果#",
                  "#售后链接#",
                ],
              },
            },
            {
              tittle: "直播下单关怀",
              path: "shopLiveOrderRemind",
              name: "shopLiveOrderRemind",
              component: (resolve) => {
                require(["./views/care/page-order-care.vue"], resolve);
              },
              meta: {
                isOfficial: true,
                officialType: 28,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#退款金额#",
                  "#申请退款日期#",
                  "#审核退款结果#",
                  "#售后链接#",
                ],
              },
            },
          ],
        },
        // 事件-自动化营销
        {
          path: "auto_market_official_module",
          redirect: { name: "goods_repurchase" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "marketing_model",
              name: "marketing_model",
              component: (resolve) => {
                require(["./views/manage/auto_market_official_module.vue"], resolve);
              },
              meta: {
                desc: "针对多天未成交的客户，发送一条促销短信，提醒客户进行复购",
                itemIndex: 2,
                title: "自动化营销"
              },
            },
            {
              path: "daily_operations",
              name: "daily_operations",
              component: (resolve) => {
                // require(["./views/manage/daily_operations.vue"], resolve);
                require(["./views/manage/auto_market_official_module.vue"], resolve);
              }
            },
            {
              path: "big_promotion_marketing",
              name: "big_promotion_marketing",
              component: (resolve) => {
                // require(["./views/manage/big_promotion_marketing.vue"], resolve);
                require(["./views/manage/auto_market_official_module.vue"], resolve);
              }
            },
          ]
        },
        // 事件-自动化营销（旧）
        {
          path: "auto_marketing",
          redirect: { name: "商品复购" },
          component: (resolve) => {
            require(["./views/manage/autoMarket/index.vue"], resolve);
          },
          children: [
            {
              path: "goods_repurchase",
              name: "商品复购",
              component: (resolve) => {
                require(["./views/manage/autoMarket/auto_market.vue"], resolve);
              },
              meta: {
                desc:
                  "根据商品的消耗周期，在商品即将消耗完的时候发送提醒，引导复购",
                itemIndex: 1,
                taskType: 25,
                isOfficial: true,
                officialType: '20',
                smsLabel: [
                  "#买家昵称#",
                  "#会员等级#",
                  "#最近一次购买时间#",
                  "#交易总额#",
                  "#交易笔数#",
                  "#距今多久未购买#",
                ],
                title: "自动化营销（旧）"
              },
            },
            {
              path: "first_purchase",
              name: "首购有礼",
              component: (resolve) => {
                require(["./views/manage/autoMarket/auto_market.vue"], resolve);
              },
              meta: {
                desc:
                  "对首次在店铺购买的客户发送关怀，或者推送搭配商品，引导复购",
                itemIndex: 2,
                isOfficial: true,
                officialType: '20',
                taskType: 15,
                smsLabel: [
                  "#买家昵称#",
                  "#最近一次购买时间#",
                  "#交易总额#",
                  "#交易笔数#",
                ],
              },
            },
            {
              path: "repurchase",
              name: "复购有礼",
              component: (resolve) => {
                require(["./views/manage/autoMarket/auto_market.vue"], resolve);
              },
              meta: {
                desc: "对再次进店购买的客户发送关怀，引导下次进店复购",
                itemIndex: 3,
                taskType: 16,
                isOfficial: true,
                officialType: '20',
                smsLabel: [
                  "#买家昵称#",
                  "#会员等级#",
                  "#最近一次购买时间#",
                  "#交易总额#",
                  "#交易笔数#",
                  "#距今多久未购买#",
                ],
              },
            },
            {
              path: "sleep_remind",
              name: "休眠提醒",
              component: (resolve) => {
                require(["./views/manage/autoMarket/auto_market.vue"], resolve);
              },
              meta: {
                desc:
                  "对长时间没有进店购买的客户发送短信关怀，唤醒客户记忆回店购买",
                itemIndex: 4,
                taskType: 17,
                isOfficial: true,
                officialType: '20',
                smsLabel: [
                  "#买家昵称#",
                  "#会员等级#",
                  "#最近一次购买时间#",
                  "#交易总额#",
                ],
              },
            },
            {
              path: "fullmonthgift",
              name: "满月礼",
              component: (resolve) => {
                require(["./views/manage/autoMarket/auto_market.vue"], resolve);
              },
              meta: {
                desc:
                  "在距离客户首次购买满30天的时候发送短信关怀，引导进店复购",
                itemIndex: 5,
                taskType: 18,
                isOfficial: true,
                officialType: '20',
                smsLabel: [
                  "#买家姓名#",
                  "#买家昵称#",
                  "#会员等级#",
                  "#最近一次购买时间#",
                  "#最早购买时间#",
                  "#交易总额#",
                ],
              },
            },
            {
              path: "hundred_day_gift",
              name: "百日礼",
              component: (resolve) => {
                require(["./views/manage/autoMarket/auto_market.vue"], resolve);
              },
              meta: {
                desc:
                  "距离客户购买满100天的时候，发送一条关怀短信，引导进店复购",
                itemIndex: 6,
                taskType: 19,
                isOfficial: true,
                officialType: '20',
                smsLabel: [
                  "#买家姓名#",
                  "#买家昵称#",
                  "#会员等级#",
                  "#最近一次购买时间#",
                  "#最早购买时间#",
                  "#交易总额#",
                ],
              },
            },
            {
              path: "anniversary",
              name: "周年庆",
              component: (resolve) => {
                require(["./views/manage/autoMarket/auto_market.vue"], resolve);
              },
              meta: {
                desc: "距离客户购买满1年的时候,发送一条关怀短信，引导进店复购",
                itemIndex: 7,
                taskType: 20,
                isOfficial: true,
                officialType: '20',
                smsLabel: [
                  "#买家姓名#",
                  "#买家昵称#",
                  "#会员等级#",
                  "#最近一次购买时间#",
                  "#最早购买时间#",
                  "#交易总额#",
                ],
              },
            },
            {
              path: "memberbill",
              name: "会员账单",
              component: (resolve) => {
                require(["./views/manage/autoMarket/auto_market.vue"], resolve);
              },
              meta: {
                desc:
                  "开启后，给店铺客户自动发送月度消费账单，引导进店复购享受优惠",
                itemIndex: 8,
                taskType: 21,
                smsLabel: [
                  "#买家昵称#",
                  " #会员等级#",
                  "#最近一次购买时间#",
                  "#距今多久未购买#",
                  "#交易总额#",
                  "#交易笔数#",
                ],
              },
            },
            {
              path: "activity",
              name: "活动码",
              component: (resolve) => {
                require(["./views/manage/autoMarket/activity.vue"], resolve);
              },
              meta: {
                desc:
                  "开启后，给店铺客户自动发送上月账单，提醒买家进店享受优惠",
                itemIndex: 9,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                  "#活动码#",
                ],
              },
            },
          ],
        },
        // 自定义营销
        {
          path: "cusMarketing",
          name: "cusMarketing",
          component: (resolve) => {
            require(["./views/manage/cusMarketing.vue"], resolve);
          },
          meta: {
            desc: "自定义营销",
          },
        },
      ],
    },
    // 会员
    {
      path: "/member",
      redirect: { name: "mutualMember" },
      component: (resolve) => {
        require(["./views/router_page1.vue"], resolve);
      },
      children: [
        {
          path: "",
          redirect: { name: "mutualMember" },
        },
        {
          path: "memberLevel",
          name: "memberLevel",
          component: (resolve) => {
            require(["./views/member/memberLevel.vue"], resolve);
          },
          meta: {
            title: "会员等级"
          }
        },
        {
          path: "batchDistributionBenefits",
          name: "batchDistributionBenefits",
          component: (resolve) => {
            require(["./views/member/batchDistributionBenefits.vue"], resolve);
          },
          meta: {
            title: "权益发放"
          }
        },
        {
          path: "pointsManagement",
          name: "pointsManagement",
          component: (resolve) => {
            require(["./views/member/pointsManagement.vue"], resolve);
          },
          meta: {
            title: "多倍积分"
          }
        },
        {
          path: "channel",
          name: "channel",
          component: (resolve) => {
            require(["./views/member/channel.vue"], resolve);
          },
          meta: {
            title: "入会渠道"
          }
        },
        {
          path: "shopDecoration",
          name: "shopDecoration",
          component: (resolve) => {
            require(["./views/member/shopDecoration.vue"], resolve);
          },
          meta: {
            title: "会员页装修"
          }
        },
        { // 会员等级权益
          path: "memberShipLevel",
          name: "memberShipLevel",
          component: (resolve) => {
            require(["./views/member/memberShipLevel.vue"], resolve);
          },
          meta: {
            title: "会员等级权益"
          }
        },
        {
          path: "zhipuDecoration",
          name: "zhipuDecoration",
          component: (resolve) => {
            require(["./views/member/zhipuDecoration.vue"], resolve);
          },
          meta: {
            title: "店铺装修"
          }
        },
        // 会员预览页
        {
          path: "channel_pre",
          name: "channel_pre",
          component: (resolve) => {
            require(["./views/BI/preview.vue"], resolve);
          },
        },
        {
          path: "batchDistributionBenefits_pre",
          name: "batchDistributionBenefits_pre",
          component: (resolve) => {
            require(["./views/BI/preview.vue"], resolve);
          },
        },
        {
          path: "zhipuDecoration_pre",
          name: "zhipuDecoration_pre",
          component: (resolve) => {
            require(["./views/BI/preview.vue"], resolve);
          },
        },
        {
          path: "memberShipLevel_pre",
          name: "memberShipLevel_pre",
          component: (resolve) => {
            require(["./views/BI/preview.vue"], resolve);
          },
        },
        {
          path: "pointsManagement_pre",
          name: "pointsManagement_pre",
          component: (resolve) => {
            require(["./views/BI/preview.vue"], resolve);
          },
        },
        {
          path: "memberLevel_pre",
          name: "memberLevel_pre",
          component: (resolve) => {
            require(["./views/BI/preview.vue"], resolve);
          },
        },
        {
          path: "shopDecoration_pre",
          name: "shopDecoration_pre",
          component: (resolve) => {
            require(["./views/BI/preview.vue"], resolve);
          },
        },
      ],
    },
    // 售后中心
    {
      path: "/serviceCenter",
      component: (resolve) => {
        require(["./views/router_page.vue"], resolve);
      },
      children: [
        {
          path: "",
          redirect: { name: "manualurg" },
        },
        {
          path: "evaluate",
          redirect: { name: "manualurg" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "manualurg" },
            },
            {
              path: "manualurg",
              name: "manualurg",
              component: (resolve) => {
                require(["./views/serviceCenter/manualurg.vue"], resolve);
              },
            },
            {
              path: "manualReply",
              name: "manualReply",
              component: (resolve) => {
                require(["./views/serviceCenter/manualReply.vue"], resolve);
              },
            },
            {
              path: "autoassess",
              name: "autoassess",
              component: (resolve) => {
                require(["./views/serviceCenter/autoassess.vue"], resolve);
              },
            },
          ],
        },
        {
          path: "refundCenter",
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "manualRefund",
              name: "manualRefund",
              component: (resolve) => {
                require(["./views/serviceCenter/manualRefund.vue"], resolve);
              },
            },
            {
              path: "autoRefund",
              name: "autoRefund",
              component: (resolve) => {
                require(["./views/serviceCenter/autoRefund.vue"], resolve);
              },
            },
          ],
        },
        {
          path: "shopWarning",
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "commentWarning",
              name: "commentWarning",
              component: (resolve) => {
                require(["./views/serviceCenter/commentWarning.vue"], resolve);
              },
            },
            {
              path: "refundWarning",
              name: "refundWarning",
              component: (resolve) => {
                require(["./views/serviceCenter/refundWarning.vue"], resolve);
              },
            },
          ],
        },
        {
          path: "asesAnalysis",
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "allGoodsAssess",
              name: "allGoodsAssess",
              component: (resolve) => {
                require(["./views/serviceCenter/allGoodsAssess.vue"], resolve);
              },
            },
            {
              path: "goodsMonitor",
              name: "goodsMonitor",
              component: (resolve) => {
                require(["./views/serviceCenter/goodsMonitor.vue"], resolve);
              },
            },
            {
              path: "delMonitor",
              name: "delMonitor",
              component: (resolve) => {
                require(["./views/serviceCenter/delMonitor.vue"], resolve);
              },
            },
          ],
        },
      ],
    },

    //客户营销
    {
      path: "/marketing",
      component: (resolve) => {
        require(["./views/router_page.vue"], resolve);
      },
      children: [
        {
          path: "",
          redirect: { name: "groupingX" },
        },
        // 营销-人群营销
        {
          path: "accurate_market",
          name: "accurate_market",
          component: (resolve) => {
            require(["./views/manage/marketing_record.vue"], resolve);
          },
          meta: {
            desc: "人群营销",
            typeIndex: 1, // 1.表示精准营销
          },
        },
        // 营销-智能营销
        {
          path: "intelligent_market",
          name: "intelligentMarket",
          component: (resolve) => {
            require(["./views/intelligentMarket/index.vue"], resolve);
          },
          meta: {
            title: "智能营销"
          },
        },
        // 营销-订单发送
        {
          path: "order_sent",
          name: "order_sent",
          component: (resolve) => {
            require(["./views/manage/marketing_record.vue"], resolve);
          },
          meta: {
            desc: "订单发送",
            typeIndex: 5, // 5.表示订单发送
          },
        },
        // 营销-预售订单发送pop
        {
          path: "pop_presell_order_send",
          name: "pop_presell_order_send",
          component: (resolve) => {
            require(["./views/presellsend/index.vue"], resolve);
          },
          meta: {
            desc: "预售订单发送",
          }
        },
        // 预售订单发送自营
        {
          path: "self_presell_order_send",
          name: "self_presell_order_send",
          component: (resolve) => {
            require(["./views/presellsupport/index.vue"], resolve);
            // require(["./views/presellsend/index.vue"], resolve);
          },
          meta: {
            title: "预售订单发送",
          }
        },
        // 订单发送自营
        {
          path: "self_order_send",
          name: "self_order_send",
          component: (resolve) => {
            require(["./views/ordersend/index.vue"], resolve);
          },
          meta: {
            title: "订单发送",
          }
        },
        // 营销-客户发送
        {
          path: "member_send",
          name: "member_send",
          component: (resolve) => {
            require(["./views/manage/marketing_record.vue"], resolve);
          },
          meta: {
            desc: "客户发送",
            typeIndex: 2, // 2.表示精准营销
          },
        },
        // 营销-咚咚群聊
        {
          path: "chat_Marketing",
          name: "chat_Marketing",
          component: (resolve) => {
            require(["./views/manage/group_chart_market.vue"], resolve);
          },
          meta: {
            desc: "咚咚群聊"
          },
        },
        // 营销-咚咚消息
        {
          path: "dongdongMessage",
          name: "dongdongMessage",
          component: (resolve) => {
            require(["./views/manage/dongdongMessage.vue"], resolve);
          },
          meta: {
            desc: "咚咚消息",
          }
        },
        // 营销-营销总览
        {
          path: "sms_marketing_effect",
          name: "sms_marketing_effect", 
          component: (resolve) => {
            require(["./views/manage/sms_marketing_effect.vue"], resolve);
          },   
          meta: {
            desc: "营销复盘",
          }
        },
        //  营销-咚咚营销模型
         {
          path: "dongdong_marketing_model",
          name: "dongdong_marketing_model", 
          component: (resolve) => {
            require(["./views/manage/dongdongMarketingModel/index.vue"], resolve);
          },
          meta: {
            desc: "咚咚营销模型",
          }
        },

        {
          path: "marketing",
          redirect: { name: "groupingX" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "grouping" },
            },
            {
              path: "grouping",
              name: "groupingX",
              component: (resolve) => {
                require(["./views/manage/grouping.vue"], resolve);
              },
            },
            {
              path: "member_grouping",
              name: "member_grouping",
              component: (resolve) => {
                require(["./views/manage/member_grouping.vue"], resolve);
              },
            },
            {
              path: "black_list",
              name: "black_list",
              component: (resolve) => {
                require(["./views/manage/black_list.vue"], resolve);
              },
            },
            {
              path: "order_sent",
              name: "order_sent",
              component: (resolve) => {
                // require(['./views/marketing/order_sent.vue'], resolve)
                require(["./views/manage/marketing_record.vue"], resolve);
              },
              meta: {
                desc: "订单发送",
                typeIndex: 5, // 5.表示订单发送
              },
            },
            {
              path: "sms_record",
              name: "sms_record",
              component: (resolve) => {
                require(["./views/manage/sms_record.vue"], resolve);
              },
            },
            {
              path: "accurate_market",
              name: "accurate_market",
              component: (resolve) => {
                require(["./views/manage/marketing_record.vue"], resolve);
              },
              meta: {
                desc: "精准营销",
                typeIndex: 1, // 1.表示精准营销
              },
            },
            {
              path: "intelligent_market",
              name: "intelligentMarket",
              component: (resolve) => {
                // 智能营销
                require(["./views/intelligentMarket/index.vue"], resolve);
              }
            },
            {
              path: "exclusiveCustomersService",
              name: "exclusiveCustomersService",
              component: (resolve) => {
                require(["./views/manage/customersService.vue"], resolve);
              },
            },
            //高级发送-start
            {
              path: "sendHeight",
              name: "sendHeight",
              component: (resolve) => {
                //高级发送
                require(["./views/intelligentMarket/sendHeight.vue"], resolve);
              }
            },
            //高级发送-end
            {
              path: '/miDetal',
              name: 'miDetal',
              component: (resolve) => {
                require(['./views/intelligentMarket/Detail.vue'], resolve)
              }
            },
            // {
            //   path: "member_send",
            //   name: "member_send",
            //   component: (resolve) => {
            //     require(["./views/manage/marketing_record.vue"], resolve);
            //   },
            //   meta: {
            //     desc: "客户发送",
            //     typeIndex: 2, // 2.表示精准营销
            //   },
            // },
            {
              path: "designated_send",
              name: "designated_send",
              component: (resolve) => {
                // require(['./views/manage/designated-send.vue'], resolve)
                require(["./views/manage/marketing_record.vue"], resolve);
              },
              meta: {
                desc: "指定号码发送",
                typeIndex: 3, // 3.指定号码发送
              },
            },
            {
              path: "variables-send",
              name: "variables-send",
              component: (resolve) => {
                // require(['./views/manage/variables_send.vue'], resolve)
                require(["./views/manage/marketing_record.vue"], resolve);
              },
              meta: {
                desc: "变量短信发送",
                typeIndex: 4, // 4.变量短信发送
              },
            },
            // {
            //   path: 'marketing-record',
            //   name: 'marketing-record',
            //   component: (resolve) => {
            //     require(['./views/manage/marketing_record.vue'], resolve)
            //   },
            // },
            {
              path: "summary-analysis",
              name: "summary-analysis",
              component: (resolve) => {
                require(["./views/manage/summary_analysis.vue"], resolve);
              },
            },
            // 订单发送自营
            {
              path: "self_order_send",
              name: "self_order_send",
              component: (resolve) => {
                require(["./views/ordersend/index.vue"], resolve);
              },
            },
            // 预售订单发送pop
            // {
            //   path: "pop_presell_order_send",
            //   name: "pop_presell_order_send",
            //   component: (resolve) => {
            //     require(["./views/presellsend/index.vue"], resolve);
            //   },
            // },
            // 预售订单发送自营
            // {
            //   path: "self_presell_order_send",
            //   name: "self_presell_order_send",
            //   component: (resolve) => {
            //     require(["./views/presellsupport/index.vue"], resolve);
            //   },
            // },
            //营销数据汇总
            // {
            //   path: "sms_marketing_effect",
            //   name: "sms_marketing_effect", 
            //   component: (resolve) => {
            //     require(["./views/manage/sms_marketing_effect.vue"], resolve);
            //   },
            // },
          ],
        },
        // 自动化营销
        // {
        //   path: "auto_marketing",
        //   redirect: { name: "商品复购" },
        //   component: (resolve) => {
        //     require(["./views/manage/autoMarket/index.vue"], resolve);
        //   },
        //   children: [
        //     {
        //       path: "goods_repurchase",
        //       name: "商品复购",
        //       component: (resolve) => {
        //         require(["./views/manage/autoMarket/auto_market.vue"], resolve);
        //       },
        //       meta: {
        //         desc:
        //           "根据商品的消耗周期，在商品即将消耗完的时候发送提醒，引导复购",
        //         itemIndex: 1,
        //         taskType: 25,
        //         isOfficial: true,
        //         officialType: '20',
        //         smsLabel: [
        //           "#买家昵称#",
        //           "#会员等级#",
        //           "#最近一次购买时间#",
        //           "#交易总额#",
        //           "#交易笔数#",
        //           "#距今多久未购买#",
        //         ],
        //       },
        //     },
        //     {
        //       path: "first_purchase",
        //       name: "首购有礼",
        //       component: (resolve) => {
        //         require(["./views/manage/autoMarket/auto_market.vue"], resolve);
        //       },
        //       meta: {
        //         desc:
        //           "对首次在店铺购买的客户发送关怀，或者推送搭配商品，引导复购",
        //         itemIndex: 2,
        //         isOfficial: true,
        //         officialType: '20',
        //         taskType: 15,
        //         smsLabel: [
        //           "#买家昵称#",
        //           "#最近一次购买时间#",
        //           "#交易总额#",
        //           "#交易笔数#",
        //         ],
        //       },
        //     },
        //     {
        //       path: "repurchase",
        //       name: "复购有礼",
        //       component: (resolve) => {
        //         require(["./views/manage/autoMarket/auto_market.vue"], resolve);
        //       },
        //       meta: {
        //         desc: "对再次进店购买的客户发送关怀，引导下次进店复购",
        //         itemIndex: 3,
        //         taskType: 16,
        //         isOfficial: true,
        //         officialType: '20',
        //         smsLabel: [
        //           "#买家昵称#",
        //           "#会员等级#",
        //           "#最近一次购买时间#",
        //           "#交易总额#",
        //           "#交易笔数#",
        //           "#距今多久未购买#",
        //         ],
        //       },
        //     },
        //     {
        //       path: "sleep_remind",
        //       name: "休眠提醒",
        //       component: (resolve) => {
        //         require(["./views/manage/autoMarket/auto_market.vue"], resolve);
        //       },
        //       meta: {
        //         desc:
        //           "对长时间没有进店购买的客户发送短信关怀，唤醒客户记忆回店购买",
        //         itemIndex: 4,
        //         taskType: 17,
        //         isOfficial: true,
        //         officialType: '20',
        //         smsLabel: [
        //           "#买家昵称#",
        //           "#会员等级#",
        //           "#最近一次购买时间#",
        //           "#交易总额#",
        //         ],
        //       },
        //     },
        //     {
        //       path: "fullmonthgift",
        //       name: "满月礼",
        //       component: (resolve) => {
        //         require(["./views/manage/autoMarket/auto_market.vue"], resolve);
        //       },
        //       meta: {
        //         desc:
        //           "在距离客户首次购买满30天的时候发送短信关怀，引导进店复购",
        //         itemIndex: 5,
        //         taskType: 18,
        //         isOfficial: true,
        //         officialType: '20',
        //         smsLabel: [
        //           "#买家姓名#",
        //           "#买家昵称#",
        //           "#会员等级#",
        //           "#最近一次购买时间#",
        //           "#最早购买时间#",
        //           "#交易总额#",
        //         ],
        //       },
        //     },
        //     {
        //       path: "hundred_day_gift",
        //       name: "百日礼",
        //       component: (resolve) => {
        //         require(["./views/manage/autoMarket/auto_market.vue"], resolve);
        //       },
        //       meta: {
        //         desc:
        //           "距离客户购买满100天的时候，发送一条关怀短信，引导进店复购",
        //         itemIndex: 6,
        //         taskType: 19,
        //         isOfficial: true,
        //         officialType: '20',
        //         smsLabel: [
        //           "#买家姓名#",
        //           "#买家昵称#",
        //           "#会员等级#",
        //           "#最近一次购买时间#",
        //           "#最早购买时间#",
        //           "#交易总额#",
        //         ],
        //       },
        //     },
        //     {
        //       path: "anniversary",
        //       name: "周年庆",
        //       component: (resolve) => {
        //         require(["./views/manage/autoMarket/auto_market.vue"], resolve);
        //       },
        //       meta: {
        //         desc: "距离客户购买满1年的时候,发送一条关怀短信，引导进店复购",
        //         itemIndex: 7,
        //         taskType: 20,
        //         isOfficial: true,
        //         officialType: '20',
        //         smsLabel: [
        //           "#买家姓名#",
        //           "#买家昵称#",
        //           "#会员等级#",
        //           "#最近一次购买时间#",
        //           "#最早购买时间#",
        //           "#交易总额#",
        //         ],
        //       },
        //     },
        //     {
        //       path: "memberbill",
        //       name: "会员账单",
        //       component: (resolve) => {
        //         require(["./views/manage/autoMarket/auto_market.vue"], resolve);
        //       },
        //       meta: {
        //         desc:
        //           "开启后，给店铺客户自动发送月度消费账单，引导进店复购享受优惠",
        //         itemIndex: 8,
        //         taskType: 21,
        //         smsLabel: [
        //           "#买家昵称#",
        //           " #会员等级#",
        //           "#最近一次购买时间#",
        //           "#距今多久未购买#",
        //           "#交易总额#",
        //           "#交易笔数#",
        //         ],
        //       },
        //     },
        //     {
        //       path: "activity",
        //       name: "活动码",
        //       component: (resolve) => {
        //         require(["./views/manage/autoMarket/activity.vue"], resolve);
        //       },
        //       meta: {
        //         desc:
        //           "开启后，给店铺客户自动发送上月账单，提醒买家进店享受优惠",
        //         itemIndex: 9,
        //         smsLabel: [
        //           "#订单号#",
        //           "#收货人姓名#",
        //           "#买家昵称#",
        //           "#下单时间#",
        //           "#订单金额#",
        //           "#活动码#",
        //         ],
        //       },
        //     },
        //   ],
        // },
        // 自动化营销 （官方） 
        {
          path: "auto_marketing_official",
          redirect: { name: "goods_repurchase" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "first_purchase_official",
              name: "first_purchase_official",
              component: (resolve) => {
                require(["./views/manage/auto_market_official.vue"], resolve);
              },
              meta: {
                desc:
                  "对首次在店铺成交的客户发送关怀，或者推送搭配商品，引导复购",
                itemIndex: 1,
              },
            },
            {
              path: "reminder_purchase_official",
              name: "reminder_purchase_official",
              component: (resolve) => {
                require(["./views/manage/auto_market_official.vue"], resolve);
              },
              meta: {
                desc: "针对多天未成交的客户，发送一条促销短信，提醒客户进行复购",
                itemIndex: 2,
              },
            },
            {
              path: "call_customer_churn",
              name: "call_customer_churn",
              component: (resolve) => {
                require(["./views/manage/auto_market_official.vue"], resolve);
              },
              meta: {
                desc: "客户超过180天未成交，自动发送关怀，唤醒客户记忆进店购买",
                itemIndex: 3,
              },
            },
            {
              path: "interest_customer_conversion",
              name: "interest_customer_conversion",
              component: (resolve) => {
                require(["./views/manage/auto_market_official.vue"], resolve);
              },
              meta: {
                desc: "近期有加购或者关注但无成交的客户持续转化",
                itemIndex: 4,
              },
            },
            {
              path: "conversion_unpurchased_members",
              name: "conversion_unpurchased_members",
              component: (resolve) => {
                require(["./views/manage/auto_market_official.vue"], resolve);
              },
              meta: {
                desc: "针对开卡入会一定时间后未购买的客户进行主动营销，提升转化率",
                itemIndex: 5,
              },
            },
            {
              path: "auto_market_official_module",
              name: "auto_market_official_module",
              component: (resolve) => {
                require(["./views/manage/auto_market_official_module.vue"], resolve);
              },
              meta: {
                desc: "针对多天未成交的客户，发送一条促销短信，提醒客户进行复购",
                itemIndex: 2,
              },
            },

          ],
        },
        //自动化营销模型
        // {
        //   path: "auto_market_official_module",
        //   redirect: { name: "goods_repurchase" },
        //   component: (resolve) => {
        //     require(["./views/router_page1.vue"], resolve);
        //   },
        //   children: [
        //     {
        //       path: "marketing_model",
        //       name: "marketing_model",
        //       component: (resolve) => {
        //         require(["./views/manage/auto_market_official_module.vue"], resolve);
        //       },
        //       meta: {
        //         desc: "针对多天未成交的客户，发送一条促销短信，提醒客户进行复购",
        //         itemIndex: 2,
        //       },
        //     },
        //     {
        //       path: "daily_operations",
        //       name: "daily_operations",
        //       component: (resolve) => {
        //         require(["./views/manage/daily_operations.vue"], resolve);
        //       }
        //     },
        //     {
        //       path: "big_promotion_marketing",
        //       name: "big_promotion_marketing",
        //       component: (resolve) => {
        //         require(["./views/manage/big_promotion_marketing.vue"], resolve);
        //       }
        //     },
        //   ]
        // },
        // {
        //   path: "auto_market_official_module",
        //   redirect: { name: "goods_repurchase" },
        //   component: (resolve) => {
        //     require(["./views/router_page1.vue"], resolve);
        //   },
        //   children: [
        //     {
        //       path: "marketing_model",
        //       name: "marketing_model",
        //       component: (resolve) => {
        //         require(["./views/manage/auto_market_official_module.vue"], resolve);
        //       },
        //       meta: {
        //         desc: "针对多天未成交的客户，发送一条促销短信，提醒客户进行复购",
        //         itemIndex: 2,
        //       },
        //     },
        //   ]
        // },
        {
          path: "chat",
          redirect: { name: "chat_Marketing" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            // {
            //   path: "chat_Marketing",
            //   name: "chat_Marketing",
            //   component: (resolve) => {
            //     require(["./views/manage/group_chart_market.vue"], resolve);
            //   },
            // },
            {
              path: "exclusiveCustomersService",
              name: "exclusiveCustomersService",
              component: (resolve) => {
                require(["./views/manage/customersService.vue"], resolve);
              },
            },
            // {
            //   path: "dongdongMessage",
            //   name: "dongdongMessage",
            //   component: (resolve) => {
            //     require(["./views/manage/dongdongMessage.vue"], resolve);
            //   },
            // }
          ]
        },
        // 短信工具
        {
          path: "sms_tool",
          redirect: { name: "signature" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "signature" },
            },
            {
              path: "signature",
              name: "signature",
              component: (resolve) => {
                require(["./views/backstage/signature_report_official.vue"], resolve);
              },
            },
            {
              path: "media_qualification",
              name: "media_qualification",
              component: (resolve) => {
                require(["./views/backstage/mediaQualification/index.vue"], resolve);
              },
            },
            {
              path: "sms_module",
              name: "sms_module",
              component: (resolve) => {
                require(["./views/backstage/sms_module.vue"], resolve);
              },
            }
          ],
        },
      ],
    },
    //数据分析
    {
      path: "/analysis",
      component: (resolve) => {
        require(["./views/router_page.vue"], resolve);
      },
      children: [
        {
          path: "",
          redirect: { name: "customerAnalysisSelfSupport" },
        },
        {
          path: 'customerAnalysisSelfSupport',
          redirect: { name: 'customerAnalysisSelfSupport' },
          component: (resolve) => {
            require(['./views/router_page1.vue'], resolve)
          },
          children: [
            {
              path: '',
              redirect: { name: 'customerAnalysisSelfSupport' },
            },
            {
              path: "customerAnalysisSelfSupport",
              name: "customerAnalysisSelfSupport",
              component: (resolve) => {
                require(["./views/analysis/customerAnalysisSelfSupport.vue"], resolve);
              },
            },
            {
              path: 'marketing_insight',
              name: 'marketing_insight',
              component: (resolve) => {
                require(['./views/analysis/marketing_insight.vue'], resolve)
              },
            },
          ]
        },
        // 评价分析
        {
          path: "comment",
          redirect: { name: "customer_portrait" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            // 商品评价分析
            {
              path: "goods_comment_analysis",
              name: "goods_comment_analysis",
              component: (resolve) => {
                require(["./views/serviceCenter/allGoodsAssess.vue"], resolve);
              },
            },
            // 删除数据监控
            {
              path: "goods_del_comment_monitor",
              name: "goods_del_comment_monitor",
              component: (resolve) => {
                require(["./views/serviceCenter/delMonitor.vue"], resolve);
              },
            },
          ],
        },
        //用户资产分析
        {
          path: "userAnalysis",
          redirect: { name: "用户资产分析" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children:[
            // 用户画像
            {
              path: "customer_portrait",
              name: "customer_portrait",
              component: (resolve) => {
                require(["./views/analysis/customerAnalysisSelfSupport.vue"], resolve);
              },
            },
            //用户资产
            {
              path: "customer_asset_analysis",
              name: "customer_asset_analysis",
              meta: {
                name: "用户资产"
              },
              component: (resolve) => {
                require(["./views/analysis/people_asset.vue"], resolve);
              },
            },
            //用户转化
            {
              path: "customer_transform_analysis",
              name: "customer_transform_analysis",
              component: (resolve) => {
                require(["./views/analysis/people_switch.vue"], resolve);
              },
            }
          ],
        },
        // 客户消费分析
        {
          path: "customer_consumer_analysis",
          name: "customer_consumer_analysis",
          meta: {
            name: "客户消费分析"
          },
          component: (resolve) => {
            require(["./views/analysis/consume_analysis.vue"], resolve);
          },
          meta: {
            name: "客户分析"
          },
        },
        //客户分析
        {
          path: "customerAnalysis",
          redirect: { name: "customer_portrait" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            // {
            //   path: 'customer_portrait',
            //   name: 'customer_portrait',
            //   component: (resolve) => {
            //     require(['./views/analysis/customer_portrait.vue'], resolve)
            //   },
            // },
            // {
            //   path: "people_level",
            //   name: "people_level",
            //   component: (resolve) => {
            //     require(["./views/analysis/people_level.vue"], resolve);
            //   },
            // },

            // 自营--客户画像
            {
              path: "customer_portrait",
              name: "customer_portrait",
              component: (resolve) => {
                require(["./views/analysis/customerAnalysisSelfSupport.vue"], resolve);
              },
            },

            // 客户转换分析
            {
              path: "customer_transform_analysis",
              name: "customer_transform_analysis",
              component: (resolve) => {
                require(["./views/analysis/people_switch.vue"], resolve);
              },
            },
            // 客户资产分析
            {
              path: "customer_asset_analysis",
              name: "customer_asset_analysis",
              meta: {
                name: "客户资产分析"
              },
              component: (resolve) => {
                require(["./views/analysis/people_asset.vue"], resolve);
              },
            },
            // 客户消费分析
            // {
            //   path: "customer_consumer_analysis",
            //   name: "customer_consumer_analysis",
            //   meta: {
            //     name: "客户消费分析"
            //   },
            //   component: (resolve) => {
            //     require(["./views/analysis/consume_analysis.vue"], resolve);
            //   },
            // },
            //销售数据分析
            {
              path: "sales_data_analysis",
              name: "sales_data_analysis",
              component: (resolve) => {
                require(["./views/analysis/sales_data_analysis.vue"], resolve);
              },
            },
            //客户排行榜
            {
              path: "customer_ranking",
              name: "customer_ranking",
              component: (resolve) => {
                require(["./views/analysis/customer_ranking.vue"], resolve);
              },
            },
            // 客户消费分析(new)
            {
              path: "customer_value_analysis",
              name: "customer_value_analysis",
              meta: {
                name: "客户价值分析"
              },
              component: (resolve) => {
                require(["./views/analysis/people_worth.vue"], resolve);
              },
            },
            // 客户流失分析
            {
              path: "customer_lost_analysis",
              name: "customer_lost_analysis",
              meta: {
                name: "客户流失分析"
              },
              component: (resolve) => {
                require(["./views/analysis/people_drain.vue"], resolve);
              },
            },
            // 地域分布分析
            {
              path: "region_distribution_analysis",
              name: "region_distribution_analysis",
              component: (resolve) => {
                require(["./views/analysis/region_distribution_analysis.vue"], resolve);
              },
            },
            // 新老客分析
            {
              path: "newAndOld_analysis",
              name: "newAndOld_analysis",
              component: (resolve) => {
                require(["./views/analysis/newAndOld_analysis.vue"], resolve);
              },
            },
            // 历史会员购买分析
            {
              path: "history_member_analysis",
              name: "history_member_analysis",
              component: (resolve) => {
                require(["./views/analysis/history_member_analysis.vue"], resolve);
              },
            },
            // 历史新老客分析
            {
              path: "history_newAndOld_analysis",
              name: "history_newAndOld_analysis",
              component: (resolve) => {
                require(["./views/analysis/history_newAndOld_analysis.vue"], resolve);
              },
            },
            // 客单价区间分析
            {
              path: "customer_unitPrice_analysis",
              name: "customer_unitPrice_analysis",
              component: (resolve) => {
                require(["./views/analysis/customer_unitPrice_analysis.vue"], resolve);
              },
            },
            // 新客留存率分析
            {
              path: "new_keep_analysis",
              name: "new_keep_analysis",
              meta: {
                title: "新客留存率分析",
              },
              component: (resolve) => {
                require(["./views/analysis/keep_analysis.vue"], resolve);
              },
            },
            // 老客留存率分析
            {
              path: "old_keep_analysis",
              name: "old_keep_analysis",
              meta: {
                title: "老客留存率分析",
              },
              component: (resolve) => {
                require(["./views/analysis/keep_analysis.vue"], resolve);
              },
            },
            {
              path: "money_analysis",
              name: "money_analysis",
              component: (resolve) => {
                require(["./views/analysis/money_analysis.vue"], resolve);
              },
            },
            {
              path: "marketing_insight",
              name: "marketing_insight",
              component: (resolve) => {
                require(["./views/analysis/marketing_insight.vue"], resolve);
              },
            },
            {
              path: "regional_analysis",
              name: "regional_analysis",
              component: (resolve) => {
                require(["./views/analysis/regional_analysis.vue"], resolve);
              },
            },
            {
              path: "amount_analysis",
              name: "amount_analysis",
              component: (resolve) => {
                require(["./views/analysis/amount_analysis.vue"], resolve);
              },
            },
            {
              path: "monthly_report",
              name: "月度报表",
              component: (resolve) => {
                require(["./views/analysis/monthly_report.vue"], resolve);
              },
            },
          ],
        },
        //RFM分析
        {
          path: "rfmAnalysis",
          redirect: { name: "RFM分析" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "RFM_standard_analysis",
              name: "RFM标准分析",
              component: (resolve) => {
                require([
                  "./views/analysis/RFM_standard_analysis.vue",
                ], resolve);
              },
            },
            {
              path: "RFM_custom_analysis",
              name: "RFM自定义分析",
              component: (resolve) => {
                require(["./views/analysis/RFM_custom_analysis.vue"], resolve);
              },
            },
            {
              path: 'RFM_custom_analysis_shop',
              name: 'RFM_custom_analysis_shop',
              component: (resolve) => {
                require(['./views/analysis/RFM_custom_analysis_shop.vue'], resolve)
              },
            },
          ],
        },
        //商品分析
        {
          path: "goods",
          redirect: { name: "商品回购周期分析" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "goods_repurchase",
              name: "商品复购周期分析",
              component: (resolve) => {
                require(["./views/analysis/goods_repurchase.vue"], resolve);
              },
            },
            {
              path: "goods_combine",
              name: "商品销售连带分析",
              component: (resolve) => {
                require(["./views/analysis/goods_combine.vue"], resolve);
              },
            },
            {
              path: "goods_analysis",
              name: "商品交易透视",
              component: (resolve) => {
                require(["./views/analysis/goods_analysis.vue"], resolve);
              },
            },
            {
              path: "goods_saleAnalysis",
              name: "商品销售分析",
              component: (resolve) => {
                require(["./views/analysis/goods_saleAnalysis.vue"], resolve);
              },
            },
            {
              path: "category_saleAnalysis",
              name: "类目销售分析",
              component: (resolve) => {
                require(["./views/analysis/category_saleAnalysis.vue"], resolve);
              },
            },
            {
              path: "category_JointAnalysis",
              name: "类目连带分析",
              component: (resolve) => {
                require(["./views/analysis/category_JointAnalysis.vue"], resolve);
              },
            },
          ],
        },
        //订单分析
        {
          path: "order",
          redirect: { name: "下单未付款分析" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "order_nopay",
              name: "下单未付款分析",
              component: (resolve) => {
                require(["./views/analysis/order_analysis.vue"], resolve);
              },
            },
            {
              path: "payment_cycle",
              name: "付款周期分析",
              component: (resolve) => {
                require(["./views/analysis/order_payCycle.vue"], resolve);
              },
            },
            {
              path: "refund",
              name: "退款分析",
              component: (resolve) => {
                require(["./views/analysis/order_refund.vue"], resolve);
              },
            },
            {
              path: "valuation",
              name: "评价分析",
              component: (resolve) => {
                require(["./views/analysis/valuation.vue"], resolve);
              },
            },
          ],
        },
        //会员分析
        {
          path: "memberAnalysis",
          redirect: { name: "会员资产分析" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children:[
            // 会员资产分析
            {
              path: "member_asset_analysis",
              name: "member_asset_analysis",
              component: (resolve) => {
                require(["./views/analysis/member_asset_analysis.vue"], resolve);
              },
            },
            //会员等级分析
            {
              path: "member_level_analysis",
              name: "member_level_analysis",
              component: (resolve) => {
                require(["./views/analysis/member_level_analysis.vue"], resolve);
              },
            },
            //会员积分分析
            {
              path: "member_point_analysis",
              name: "member_point_analysis",
              component: (resolve) => {
                require(["./views/analysis/member_point_analysis.vue"], resolve);
              },
            },
            // 入会渠道分析
            {
              path: "member_channel_analysis",
              name: "member_channel_analysis",
              component: (resolve) => {
                require(["./views/analysis/member_channel_analysis.vue"], resolve);
              },
            }
          ],
        },
        {
          path: "jointData",
          redirect: { name: "用户资产看板" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "user_assets",
              name: "用户资产看板",
              component: (resolve) => {
                require(["./views/analysis/user_assets.vue"], resolve);
              },
            },
            {
              path: "joint_customer",
              name: "客户分析",
              component: (resolve) => {
                require(["./views/analysis/joint_customer.vue"], resolve);
              },
            },
            {
              path: "joint_member",
              name: "会员分析",
              component: (resolve) => {
                require(["./views/analysis/joint_member.vue"], resolve);
              },
            },
            {
              path: "shop_sales",
              name: "店铺销售对比",
              component: (resolve) => {
                require(["./views/analysis/shop_sales.vue"], resolve);
              },
            },
            {
              path: "shop_goods",
              name: "店铺商品分析",
              component: (resolve) => {
                require(["./views/analysis/shop_goods.vue"], resolve);
              },
            },
            {
              path: "shop_refund",
              name: "店铺退款分析",
              component: (resolve) => {
                require(["./views/analysis/shop_refund.vue"], resolve);
              },
            },
          ],
        },
      ],
    },
    // 工具
    {
      path: "/tool",
      component: (resolve) => {
        require(["./views/router_page.vue"], resolve);
      },
      children: [
        {
          path: "",
          redirect: { name: "signature" },
        },
        // 短信工具
        {
          path: "sms_tool",
          redirect: { name: "signature" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "signature" },
            },
            {
              path: "signature",
              name: "signature",
              component: (resolve) => {
                require(["./views/backstage/signature_report_official.vue"], resolve);
              },
            },
            {
              path: "media_qualification",
              name: "media_qualification",
              component: (resolve) => {
                require(["./views/backstage/mediaQualification/index.vue"], resolve);
              },
            },
            {
              path: "sms_module",
              name: "sms_module",
              component: (resolve) => {
                require(["./views/backstage/sms_module.vue"], resolve);
              },
            }
          ],
        },
        // 短信充值
        {
          path: "backstage",
          redirect: { name: "sms_management" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "sms_management" },
            },
            {
              path: "sms_management",
              name: "sms_management",
              component: (resolve) => {
                require(["./views/backstage/sms_management.vue"], resolve);
              },
            },
            {
              path: "sms_bill",
              name: "sms_bill",
              component: (resolve) => {
                require(["./views/backstage/sms_bill.vue"], resolve);
              },
            },
            {
              path: "sms_module",
              name: "smsModule",
              component: (resolve) => {
                require(["./views/backstage/sms_module.vue"], resolve);
              },
            },
            {
              path: "sms_shopReCharge",
              name: "sms_shopReCharge",
              component: (resolve) => {
                require(["./views/backstage/sms_shopReCharge.vue"], resolve);
              },
            },
            {
              path: "sms_transfer",
              name: "sms_transfer",
              component: (resolve) => {
                require(["./views/backstage/sms_transfer/index.vue"], resolve);
              },
            },
            {
              path: "recharge_records",
              name: "recharge_records",
              component: (resolve) => {
                require(["./views/backstage/recharge_records.vue"], resolve);
              },
            },
          ],
        },
        // 奖品管理
        {
          path: "prizeCenter",
          redirect: { name: "couponManagement" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "couponManagement" },
            },
            {
              path: "couponManagement",
              name: "couponManagement",
              component: (resolve) => {
                require(["./views/interactiveMarketing/coupon_management.vue"], resolve);
              },
            },
            {
              path: "assetManagement",
              name: "assetManagement",
              component: (resolve) => {
                require(["./views/interactiveMarketing/asset_management.vue"], resolve);
              },
            },
            {
              path: "goodsManagement",
              name: "goodsManagement",
              component: (resolve) => {
                require(["./views/interactiveMarketing/physical/physical_management.vue"], resolve);
              },
            },
          ],
        },
        // 店铺诊断
        {
          path: 'industry',
          name: 'industry',
          meta: {
            isOther: true, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
          },
          // TODO: 店铺诊断变成前端路由，需新增页面
          component: (resolve) => {
            require(['./views/industry/industryPage'], resolve)
          }
        },
        // 店铺诊断预览
        {
          path: 'industryPreview',
          name: 'industryPreview',
          component: (resolve) => {
            require(['./views/industry/preview'], resolve)
          }
        },
        // 黑名单管理
        {
          path: "share_polite",
          name: "share_polite",
          component: (resolve) => {
            require(["./views/manage/share_polite.vue"], resolve);
          },
          meta: {
            title: "黑名单管理",
          }
        },
        // 中奖记录
        {
          path: "win_record",
          name: "win_record",
          component: (resolve) => {
            require(["./views/manage/win_record"], resolve);
          },
          meta: {
            title: "中奖查询",
          }
        },
        //咚咚消息
        {
          path: "dongdongMessageTemplate",
          name: "dongdongMessageTemplate",
          component: (resolve) => {
            require(["./views/manage/dongdongMessageTemplate"], resolve);
          },
          meta: {
            title: "咚咚消息模板",
          }
        },
        // 增值服务
        {
          name: "appreciation",
          path: "appreciation",
          component: (resolve) => {
            require(["./views/backstage/valueAddService/index.vue"], resolve);
          },
        },  
      ],
    },
    //后台管理
    {
      path: "/backstage",
      component: (resolve) => {
        require(["./views/router_page.vue"], resolve);
      },
      children: [
        {
          path: "",
          redirect: { name: "sms_management" },
        },
        {
          path: "sms_reply_record",
          name: "sms_reply_record",
          component: (resolve) => {
            require(["./views/backstage/sms_reply_record.vue"], resolve);
          },
          meta: {
            title: "发送记录",
          }
        },
        // {
        //   path: "backstage",
        //   redirect: { name: "sms_management" },
        //   component: (resolve) => {
        //     require(["./views/router_page1.vue"], resolve);
        //   },
        //   children: [
        //     {
        //       path: "",
        //       redirect: { name: "sms_management" },
        //     },
        //     {
        //       path: "sms_management",
        //       name: "sms_management",
        //       component: (resolve) => {
        //         require(["./views/backstage/sms_management.vue"], resolve);
        //       },
        //     },

        //     {
        //       path: "sms_bill",
        //       name: "sms_bill",
        //       component: (resolve) => {
        //         require(["./views/backstage/sms_bill.vue"], resolve);
        //       },
        //     },
        //     {
        //       path: "sms_module",
        //       name: "smsModule",
        //       component: (resolve) => {
        //         require(["./views/backstage/sms_module.vue"], resolve);
        //       },
        //     },
        //     {
        //       path: "sms_shopReCharge",
        //       name: "sms_shopReCharge",
        //       component: (resolve) => {
        //         require(["./views/backstage/sms_shopReCharge.vue"], resolve);
        //       },
        //     },
        //     {
        //       path: "sms_transfer",
        //       name: "sms_transfer",
        //       component: (resolve) => {
        //         require(["./views/backstage/sms_transfer/index.vue"], resolve);
        //       },
        //     },
        //     {
        //       path: "recharge_records",
        //       name: "recharge_records",
        //       component: (resolve) => {
        //         require(["./views/backstage/recharge_records.vue"], resolve);
        //       },
        //     },
        //   ],
        // },
        //系统设置
        {
          path: "account",
          redirect: { name: "account" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "account" },
            },
            {
              path: "account",
              name: "account",
              component: (resolve) => {
                require(["./views/backstage/account_settings.vue"], resolve);
              },
            },
            {
              path: "store_binding",
              name: "store_binding",
              component: (resolve) => {
                require(["./views/backstage/store_binding.vue"], resolve);
              },
            },
          ],
        },
        // 消息通知
        {
          path: "message_otification",
          redirect: { name: "receive_configuration" },
          component: (resolve) => {
            require(["./views/backstage/message_otification/receive_configuration.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "receive_configuration" },
            },
            {
              path: "receive_configuration",
              name: "receive_configuration",
              component: (resolve) => {
                require(["./views/backstage/message_otification/receive_configuration.vue"], resolve);
              },
              meta:{desc:'通知配置'}
            },
          ],
        },
        //签名报备
        {
          path: "signature_management",
          redirect: { name: "signature_management" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "signature_management" },
            },
            {
              path: "signature_management",
              name: "signature_management",
              component: (resolve) => {
                require([
                  "./views/backstage/signature_management.vue",
                ], resolve);
              },
            },
            {
              path: "signature_report_official",
              name: "signature_report_official",
              component: (resolve) => {
                require([
                  "./views/backstage/signature_report_official.vue",
                ], resolve);
              },
            },
          ],
        },
        //签名设置
        // {
        //   name: 'signature_set',
        //   path: 'signature_set',
        //   component: (resolve) => {
        //     require(['./views/backstage/signature_set.vue'], resolve)
        //   }
        // },
        //帮助中心
        // {
        //   path: 'online_service',
        //   name: 'online_service',
        //   component: (resolve) => {
        //     require(['./views/backstage/online_service.vue'], resolve)
        //   }
        // },
        // 富信资质
        {
          name: "media_qualification",
          path: "media_qualification",
          component: (resolve) => {
            require(["./views/backstage/mediaQualification/index.vue"], resolve);
          },
        },
        // 导出管理
        {
          name: "export_management",
          path: "export_management",
          component: (resolve) => {
            require(["./views/backstage/exportManagement/index.vue"], resolve);
          },
          meta: {
            title:'导出管理'
          }
        },

        //邀请好友赚积分
        {
          name: "invite_friends",
          path: "invite_friends",
          component: (resolve) => {
            require(["./views/backstage/invite_friends.vue"], resolve);
          },
        },
        // 接入店铺
        {
          name: "access_store",
          path: "access_store",
          component: (resolve) => {
            require(["./views/accessStore/index.vue"], resolve);
          },
        },
        // 权限管理
        {
          path: "permission_management",
          redirect: { name: "permission_management" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "dept_management" },
            },
            {
              path: "dept_management",
              name: "dept_management",
              component: (resolve) => {
                require(["./views/permissionManagement/dept/index.vue"], resolve);
              },
            },
            {
              path: "role_management",
              name: "role_management",
              component: (resolve) => {
                require(["./views/permissionManagement/role/index.vue"], resolve);
              },
            },
            {
              path: "employee_management",
              name: "employee_management",
              component: (resolve) => {
                require(["./views/permissionManagement/employee/index.vue"], resolve);
              },
            },
          ],
        },
      ],
    },
    //积分中心
    {
      path: "/integralCenter",
      component: (resolve) => {
        require(["./views/router_page.vue"], resolve);
      },
      children: [
        {
          path: "",
          redirect: { name: "mutualMember" },
        },
        {
          path: "integralCenter",
          redirect: { name: "mutualMember" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "mutualMember" },
            },
            {
              path: "mutualMember",
              name: "mutualMember",
              component: (resolve) => {
                require([
                  "./views/integralCenter/memberCenter/mutualMember.vue",
                ], resolve);
              },
            },
            {
              path: "memberLevel",
              name: "memberLevel",
              component: (resolve) => {
                require([
                  "./views/integralCenter/memberCenter/memberLevel.vue",
                ], resolve);
              },
            },
            {
              path: "memberPower",
              name: "memberPower",
              component: (resolve) => {
                require([
                  "./views/integralCenter/memberCenter/memberPower.vue",
                ], resolve);
              },
            },
          ],
        },
        {
          path: "integralTask",
          name: "integralTask",
          component: (resolve) => {
            require(["./views/integralCenter/integralTask.vue"], resolve);
            // require(['./views/integralCenter/memberCenter/mutualMember.vue'], resolve)
          },
        },
        {
          path: "integralEden",
          name: "integralEden",
          component: (resolve) => {
            require(["./views/integralCenter/integralEden.vue"], resolve);
          },
        },
        {
          path: "shopDecoration",
          name: "shopDecoration",
          component: (resolve) => {
            require(["./views/integralCenter/shopDecoration.vue"], resolve);
          },
        },
        {
          path: "integralMall",
          name: "integralMall",
          component: (resolve) => {
            require(["./views/integralCenter/integralMall.vue"], resolve);
          },
        },
        //奖品中心
        {
          path: 'prizeCenter',
          component: (resolve) => {
            require(['./views/router_page1.vue'], resolve)
          },
          children: [
            {
              path: '',
              redirect: { name: 'prizeCenter' }
            },
            {
              path: 'coupon_management',
              name: 'coupon_management',
              component: (resolve) => {
                require(['./views/integralCenter/coupon_management.vue'], resolve)
              }
            }, {
              path: 'asset_management',
              name: 'asset_management',
              component: (resolve) => {
                require(['./views/integralCenter/asset_management.vue'], resolve)
              }
            }
          ]
        },
        {
          path: "dataAnalysis",
          // redirect:{ name:'dataAnalysis' },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "dataAnalysis" },
            },
            {
              path: "flow_analysis",
              name: "flow_analysis",
              component: (resolve) => {
                require(["./views/integral/flow_analysis.vue"], resolve);
              },
            },
            {
              path: "prize_statistics",
              name: "prize_statistics",
              component: (resolve) => {
                require(["./views/integral/prize_statistics.vue"], resolve);
              },
            },
          ],
        },
      ],
    },
    //店铺装修
    {
      path: "/draw",
      component: (resolve) => {
        require(["./views/integralCenter/draw/draw.vue"], resolve)
      },
    },

    // 行业专区
    // 行业运营策略
    {
      path: '/industryStrategy',
      name: 'industryStrategy',
      meta: {
        isOther: true, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      },
      component: (resolve) => {
        require(['./views/industry/strategy'], resolve)
      }
    },
    // 行业破圈
    {
      path: '/industrySolution',
      name: 'industrySolution',
      meta: {
        isOther: true, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      },
      component: (resolve) => {
        require(['./views/industry/breakCircle'], resolve)
      }
    },
    // 行业人群
    {
      path: '/industryCrowd',
      name: 'industryCrowd',
      meta: {
        isOther: true, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      },
      component: (resolve) => {
        require(['./views/industry/crowd'], resolve)
      }
    },
    {
      path: '/bi_preview',
      name: 'bi_preview',
      meta:{
        isFirst:true
      },
      component: (resolve) => {
        require(['./views/router_page.vue'], resolve)
      },
      children:[
        {
          path: "",
          component: (resolve) => {
            require(['./views/BI/preview.vue'], resolve)
          },
        }
      ]
    },
    {
      path: '/bi',
      name: 'bi',
      meta: {
        isOther: true, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      },
      component: (resolve) => {
        require(['./views/router_page.vue'], resolve)
      },
      children: [
        // 下单催付
        {
          path: "",
          redirect: { name: "customTable" },
        },
        //订单实时监控，平台版添加
        {
            path: "realTimeData",
            name: "realTimeData",
            component: (resolve) => {
                  require(["./views/BI/data/index.vue"], resolve);
            },
        },
        {
          path: "customTable",
          redirect: { name: "customTable" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "customTable" },
            },
            {
              path: "customTable",
              name: "customTable",
              component: (resolve) => {
                require(["./views/BI/custom/index.vue"], resolve);
              },
            },
            {
              path: "myCustomTable",
              name: "myCustomTable",
              component: (resolve) => {
                require(["./views/BI/custom/indexTable.vue"], resolve);
              },
            },
          ],
        },
        {
          path: "biAnalysis",
          redirect: { name: "marketAnalysis" },
          component: (resolve) => {
            require(["./views/BI/analysis"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "marketsales_analysis" },
            },
            {
              path: "marketAnalysis",
              redirect: { name: "marketsales_analysis" },
              component: (resolve) => {
                require(["./views/router_page.vue"], resolve);
              },
              children:[
                {
                  path:"marketsales_analysis",
                  name:"marketsales_analysis",
                  component: (resolve) => {
                    require(["./views/BI/analysis/marketAnalysis/marketsales_analysis.vue"], resolve);
                  },
                },
                {
                  path:"customersales_analysis",
                  name:"customersales_analysis",
                  component: (resolve) => {
                    require(["./views/BI/analysis/marketAnalysis/customersales_analysis.vue"], resolve);
                  },
                },
                {
                  path:"transtype_analysis",
                  name:"transtype_analysis",
                  component: (resolve) => {
                    require(["./views/BI/analysis/marketAnalysis/transtype_analysis.vue"], resolve);
                  },
                },
                {
                  path:"periodtime_analysis",
                  name:"periodtime_analysis",
                  component: (resolve) => {
                    require(["./views/BI/analysis/marketAnalysis/periodtime_analysis.vue"], resolve);
                  },
                },
                {
                  path:"tiercity_analysis",
                  name:"tiercity_analysis",
                  component: (resolve) => {
                    require(["./views/BI/analysis/marketAnalysis/tiercity_analysis.vue"], resolve);
                  },
                },
                {
                  path:"province_analysis",
                  name:"province_analysis",
                  component: (resolve) => {
                    require(["./views/BI/analysis/marketAnalysis/province_analysis.vue"], resolve);
                  },
                },
                {
                  path:"region_analysis",
                  name:"region_analysis",
                  component: (resolve) => {
                    require(["./views/BI/analysis/marketAnalysis/region_distribution_analysis.vue"], resolve);
                  },
                },
              ]
            },
            {
              path:"customerAnalysis",
              redirect: { name: "perchaseamount_analysis" },
              component: (resolve) => {
                require(["./views/router_page.vue"], resolve);
              },
              children:[
                {
                  path: "",
                  redirect: { name: "perchaseamount_analysis" },
                },
                {
                  path:"perchaseamount_analysis",
                  name:"perchaseamount_analysis",
                  component: (resolve) => {
                    require(["./views/BI/analysis/customerAnalysis/perchaseamount_analysis.vue"], resolve);
                  },
                },
                {
                  path:"perchasetimes_analysis",
                  name:"perchasetimes_analysis",
                  component: (resolve) => {
                    require(["./views/BI/analysis/customerAnalysis/perchasetimes_analysis.vue"], resolve);
                  },
                },
                {
                  path:"perchasenumber_analysis",
                  name:"perchasenumber_analysis",
                  component: (resolve) => {
                    require(["./views/BI/analysis/customerAnalysis/perchasenumber_analysis.vue"], resolve);
                  },
                },
                {
                  path:"recustomer_analysis",
                  name:"recustomer_analysis",
                  component: (resolve) => {
                    require(["./views/BI/analysis/customerAnalysis/recustomer_analysis.vue"], resolve);
                  },
                },
                {
                  path:"recustomercycle_analysis",
                  name:"recustomercycle_analysis",
                  component: (resolve) => {
                    require(["./views/BI/analysis/customerAnalysis/recustomercycle_analysis.vue"], resolve);
                  },
                },
                {
                  path:"recustomerrate_analysis",
                  name:"recustomerrate_analysis",
                  component: (resolve) => {
                    require(["./views/BI/analysis/customerAnalysis/recustomerrate_analysis.vue"], resolve);
                  },
                },
                {
                  path:"customer_analysis",
                  name:"customer_analysis",
                  component: (resolve) => {
                    require(["./views/BI/analysis/customerAnalysis/newAndOld_analysis.vue"], resolve);
                  },
                },
                {
                  path:"hiscustomer_analysis",
                  name:"hiscustomer_analysis",
                  component: (resolve) => {
                    require(["./views/BI/analysis/customerAnalysis/history_newAndOld_analysis.vue"], resolve);
                  },
                },
                {
                  path:"pricerange_analysis",
                  name:"pricerange_analysis",
                  component: (resolve) => {
                    require(["./views/BI/analysis/customerAnalysis/customer_unitPrice_analysis.vue"], resolve);
                  },
                },
                {
                  path:"newretention_analysis",
                  name:"newretention_analysis",
                  meta: {
                    title: "新客留存率分析",
                  },
                  component: (resolve) => {
                    require(["./views/BI/analysis/customerAnalysis/keep_analysis.vue"], resolve);
                  },
                },
                {
                  path:"oldretention_analysis",
                  name:"oldretention_analysis",
                  meta: {
                    title: "老客留存率分析",
                  },
                  component: (resolve) => {
                    require(["./views/BI/analysis/customerAnalysis/keep_analysis.vue"], resolve);
                  },
                },
                {
                  path:"user_keep_analysis",
                  name:"user_keep_analysis",
                  meta: {
                    title: "用户留存分析",
                  },
                  component: (resolve) => {
                    require(["./views/BI/analysis/customerAnalysis/user_keep_analysis.vue"], resolve);
                  },
                },
              ]
            },
            {
              path: "memberAnalysis",
              redirect: { name: "level_analysis" },
              component: (resolve) => {
                require(["./views/router_page.vue"], resolve);
              },
              children:[
                {
                  path: "",
                  redirect: { name: "level_analysis" },
                },
                {
                  path: "level_analysis",
                  name: "level_analysis",
                  component: (resolve) => {
                    require(["./views/BI/analysis/memberAnalysis/level_analysis.vue"], resolve);
                  },
                },
                {
                  path: "integral_analysis",
                  name: "integral_analysis",
                  component: (resolve) => {
                    require(["./views/BI/analysis/memberAnalysis/integral_analysis.vue"], resolve);
                  },
                },
                {
                  path:"bi_retention_analysis",
                  name:"bi_retention_analysis",
                  component: (resolve) => {
                    require(["./views/BI/analysis/memberAnalysis/member_retention_analysis.vue"], resolve);
                  },
                },
                {
                  path: "membertrans_analysis",
                  name: "membertrans_analysis",
                  component: (resolve) => {
                    require(["./views/BI/analysis/memberAnalysis/membertrans_analysis.vue"], resolve);
                  },
                },
                {
                  path: "incremember_analysis",
                  name: "incremember_analysis",
                  component: (resolve) => {
                    require(["./views/BI/analysis/memberAnalysis/incremember_analysis.vue"], resolve);
                  },
                },
                {
                  path: "hispurch_analysis",
                  name: "hispurch_analysis",
                  component: (resolve) => {
                    require(["./views/BI/analysis/memberAnalysis/history_member_analysis.vue"], resolve);
                  },
                },
                {
                  path: "order_member_level_analysis",
                  name: "order_member_level_analysis",
                  component: (resolve) => {
                    require(["./views/BI/analysis/memberAnalysis/order_membership/index.vue"], resolve);
                  },
                },
                {
                  path: "membership_provinces_sales_analysis",
                  name: "membership_provinces_sales_analysis",
                  component: (resolve) => {
                    require(["./views/BI/analysis/memberAnalysis/membership_provinces_sales_analysis.vue"], resolve);
                  },
                },
              ]
            },
            {
              path: "commodityAnalysis",
              redirect: { name: "newcustomer_analysis" },
              component: (resolve) => {
                require(["./views/router_page.vue"], resolve);
              },
              children: [
                {
                  path: "",
                  redirect: { name: "newcustomer_analysis" },
                },
                {
                  path:"newcustomer_analysis",
                  name:"newcustomer_analysis",
                  component: (resolve) => {
                    require(["./views/BI/analysis/commodityAnalysis/newcustomer_analysis.vue"], resolve);
                  },
                },
                {
                  path:"oldcustomer_analysis",
                  name:"oldcustomer_analysis",
                  component: (resolve) => {
                    require(["./views/BI/analysis/commodityAnalysis/oldcustomer_analysis.vue"], resolve);
                  },
                },
                {
                  path:"repurchase_analysis",
                  name:"repurchase_analysis",
                  component: (resolve) => {
                    require(["./views/BI/analysis/commodityAnalysis/repurchase_analysis.vue"], resolve);
                  },
                },
                {
                  path:"sales_analysis",
                  name:"sales_analysis",
                  component: (resolve) => {
                    require(["./views/BI/analysis/commodityAnalysis/sales_analysis.vue"], resolve);
                  },
                },
                {
                  path:"category_analysis",
                  name:"category_analysis",
                  component: (resolve) => {
                    require(["./views/BI/analysis/commodityAnalysis/category_analysis.vue"], resolve);
                  },
                },
                {
                  path:"presale_analysis",
                  name:"presale_analysis",
                  component: (resolve) => {
                    require(["./views/BI/analysis/commodityAnalysis/presale_analysis.vue"], resolve);
                  },
                },
                {
                  path:"sku_provinces_sales_analysis",
                  name:"sku_provinces_sales_analysis",
                  component: (resolve) => {
                    require(["./views/BI/analysis/commodityAnalysis/sku_provinces_sales_analysis.vue"], resolve);
                  },
                },
              ]
            },
            {
              path: "milkCategory",
              redirect: { name: "recruitData" },
              component: (resolve) => {
                require(["./views/router_page.vue"], resolve);
              },
              children: [
                {
                  path: "",
                  redirect: { name: "recruitData" },
                },
                {
                  path:"recruitData",
                  name:"recruitData",
                  component: (resolve) => {
                    require(["./views/BI/analysis/milkCategory/recruitData.vue"], resolve);
                  },
                },
                {
                  path:"saleData",
                  name:"saleData",
                  component: (resolve) => {
                    require(["./views/BI/analysis/milkCategory/saleData.vue"], resolve);
                  },
                },
                {
                  path:"distributionItem",
                  name:"distributionItem",
                  component: (resolve) => {
                    require(["./views/BI/analysis/milkCategory/distributionItem.vue"], resolve);
                  },
                },
                {
                  path:"distributionPot",
                  name:"distributionPot",
                  component: (resolve) => {
                    require(["./views/BI/analysis/milkCategory/distributionPot.vue"], resolve);
                  },
                },
                // 购买分布（按人数）
                {
                  path:"distributionUserNum",
                  name:"distributionUserNum",
                  component: (resolve) => {
                    require(["./views/BI/analysis/milkCategory/distributionUserNum.vue"], resolve);
                  },
                },
                // 老客复购率（按时间）
                {
                  path:"rebuyTime",
                  name:"rebuyTime",
                  component: (resolve) => {
                    require(["./views/BI/analysis/milkCategory/rebuyTime.vue"], resolve);
                  },
                },
                // 老客复购率（按段位）
                {
                  path:"rebuyDan",
                  name:"rebuyDan",
                  component: (resolve) => {
                    require(["./views/BI/analysis/milkCategory/rebuyDan.vue"], resolve);
                  },
                },
                // 复购数据
                {
                  path:"rebuyData",
                  name:"rebuyData",
                  component: (resolve) => {
                    require(["./views/BI/analysis/milkCategory/rebuyData.vue"], resolve);
                  },
                },
              ]   
            }
          ],
        },
        {
          path: "tailorTable",
          component:(resolve)=>{
            require(["./views/BI/tailor"],resolve)
          }
        }
      ],
    },
    // 行业专区京获客引导页
    {
      path: '/jhkGuide',
      name: 'jhkGuide',
      component: (resolve) => {
        require(['./views/industry/jhkGuide'], resolve)
      }
    },
    // 行业专区预览页
    {
      path: '/industryPreview',
      name: 'industryPreview',
      component: (resolve) => {
        require(['./views/industry/preview'], resolve)
      }
    },
    // 高级功能列表开发
    // {
    //   path: 'show_advanced_version',
    //   name: 'show_advanced_version',
    //   component: (resolve) => {
    //     require(["./views/advancedVersion.vue"], resolve);
    //   },
    //   meta: {
    //     typeIndex: 0, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
    //   }
    // },
    {
      path: '/*/*/*_version1',
      name: 'commodity_analysis_version',
      component: (resolve) => {
        require(["./views/advancedVersion.vue"], resolve);
      },
      meta: {
        typeIndex: 0, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      }
    },
    {
      path: '/*/*_version1',
      name: 'commodity_analysis_version',
      component: (resolve) => {
        require(["./views/advancedVersion.vue"], resolve);
      },
      meta: {
        typeIndex: 0, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      }
    },
    {
      path: '/*/*/*_version2',
      name: 'auto_market_version',
      component: (resolve) => {
        require(["./views/advancedVersion.vue"], resolve);
      },
      meta: {
        typeIndex: 1, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      }
    },
    {
      path: '/*/*_version2',
      name: 'auto_market_version',
      component: (resolve) => {
        require(["./views/advancedVersion.vue"], resolve);
      },
      meta: {
        typeIndex: 1, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      }
    },
    {
      path: '/*/*/*_version3',
      name: 'loyalty_selft_version',
      component: (resolve) => {
        require(["./views/advancedVersion.vue"], resolve);
      },
      meta: {
        typeIndex: 2, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      }
    },
    {
      path: '/*/*_version3',
      name: 'loyalty_selft_version',
      component: (resolve) => {
        require(["./views/advancedVersion.vue"], resolve);
      },
      meta: {
        typeIndex: 2, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      }
    },
    {
      path: '/*/*/*_version4',
      name: 'loyalty_pop_version',
      component: (resolve) => {
        require(["./views/advancedVersion.vue"], resolve);
      },
      meta: {
        typeIndex: 3, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      }
    },
    {
      path: '/*/*_version4',
      name: 'loyalty_pop_version',
      component: (resolve) => {
        require(["./views/advancedVersion.vue"], resolve);
      },
      meta: {
        typeIndex: 3, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      }
    },
    // 订单关怀
    {
      path: '/*/*/*_preview',
      name: 'orderCare_preview',
      component: (resolve) => {
        require(["./views/advancedVersion.vue"], resolve);
      },
      meta: {
        typeIndex: 4, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      }
    },
    {
      path: '/*/*_preview',
      name: 'orderCare_preview',
      component: (resolve) => {
        require(["./views/advancedVersion.vue"], resolve);
      },
      meta: {
        typeIndex: 4, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      }
    },
    // 互动
    {
      path: "/interactiveMarketing",
      component: (resolve) => {
        require(["./views/router_page.vue"], resolve);
      },
      children: [
        {
          path: "",
          redirect: { name: "interactiveSquare" },
        },
        // 互动-活动复盘
        {
          path: "acitivity_review",
          name: "acitivity_review",
          component: (resolve) => {
            require(["./views/interactiveMarketing/acitivityReview/index.vue"], resolve);
          },
          meta: {
            title: "活动复盘"
          }
        },
        //实物奖品名单
        {
          path: "gift_list",
          name: "gift_list",
          component: (resolve) => {
            require(["./views/interactiveMarketing/gift_list/index.vue"], resolve);
          },
          meta: {
            title: "实物奖品名单"
          }
        },
        //AI测肤
        {
          path: "ai_skin_test",
          name: "ai_skin_test",
          component: (resolve) => {
            require(["./views/interactiveMarketing/ai_skin_test/index.vue"], resolve);
          },
          meta: {
            title: "AI测肤"
          }
        },
        // 互动-中奖名单
        {
          path: "winReport",
          name: "winReport",
          component: (resolve) => {
            require(["./views/router_page.vue"], resolve);
          },
          children: [
            {
              path: "winListDecoration",
              name: "winListDecoration",
              component: (resolve) => {
                require(["./views/interactiveMarketing/winList/finish.vue"], resolve);
              },
            },
            {
              path: "winReportList",
              name: "winReportList",
              component: (resolve) => {
                require(["./views/interactiveMarketing/winList/winRecords.vue"], resolve);
              },
            }
          ]
        },
        // 互动-计量单位
        {
          path: "interactiveMeasure_Unit",
          name: "interactiveMeasure_Unit",
          component: (resolve) => {
            require(["./views/interactiveMarketing/measuringUnit/index.vue"], resolve);
          },
          meta: {
            title: "计量单位管理"
          }
        },
        
        // 互动-促销工具
        {
          path: "promo",
          name: "promo",
          component: (resolve) => {
            require(["./views/router_page.vue"], resolve);
          },
          children: [
            {
              path: "promoCreate",
              name: "promoCreate",
              component: (resolve) => {
                require(["./views/interactiveMarketing/promo/index.vue"], resolve);
              },
            },
            {
              path: "promoList",
              name: "promoList",
              component: (resolve) => {
                require(["./views/interactiveMarketing/promo/list.vue"], resolve);
              },
            }
          ]
        },
        // 互动-互动广场
        {
          path: "interactiveSquare",
          name: "interactiveSquare",
          component: (resolve) => {
            require(["./views/interactiveMarketing/interactiveSquare.vue"], resolve);
          },
        },
        // 互动-活动管理
        {
          path: "activityManagement",
          name: "activityManagement",
          // component: (resolve) => {
          //   require(["./views/interactiveMarketing/activityManagement.vue"], resolve);
          // },
          component: require("./views/interactiveMarketing/activityManagement.vue").default,
          meta: {
            title: "活动管理"
          }
        },
        //积分竞拍 
        {
          path: "point_auction",
          name: "point_auction",
          // component: (resolve) => {
          //   require(["./views/interactiveMarketing/activityManagement.vue"], resolve);
          // },
          component: require("./views/interactiveMarketing/point_auction.vue").default,
          meta: {
            title: "积分竞拍"
          }
        },
        // 赚积分任务
        {
          path: "earnPointsTasks",
          name: "earnPointsTasks",
          component: (resolve) => {
            require(["./views/interactiveMarketing/components/earnPointsTask/index.vue"], resolve);
          },
          meta: {
            title: "赚积分任务"
          }
        },
        //小部件
        {
          path: "widget",
          name: "widget",
          component: (resolve) => {
            require(["./views/interactiveMarketing/widgets/index.vue"], resolve);
          },
          meta: {
            title: "小部件"
          }
        },
        // 小程序设置
        {
          path: "mini_program_config",
          name: "mini_program_config",
          component: (resolve) => {
            require(["./views/interactiveMarketing/miniProgramConfig.vue"], resolve);
          },
          meta: {
            title: "小程序设置"
          }
        },
        // 互动-预览页
        {
          path: "interactiveSquare_pre",
          name: "interactiveSquare_pre",
          component: (resolve) => {
            require(["./views/BI/preview.vue"], resolve);
          },
        },
        {
          path: "promo_pre",
          name: "promo_pre",
          component: (resolve) => {
            require(["./views/BI/preview.vue"], resolve);
          },
        },
        {
          path: "activityManagement_pre",
          name: "activityManagement_pre",
          component: (resolve) => {
            require(["./views/BI/preview.vue"], resolve);
          },
        },
        {
          path: "unitedPromotionActivity_pre",
          name: "unitedPromotionActivity_pre",
          component: (resolve) => {
            require(["./views/BI/preview.vue"], resolve);
          },
        },
        {
          path: "promotionActivity_pre",
          name: "promotionActivity_pre",
          component: (resolve) => {
            require(["./views/BI/preview.vue"], resolve);
          },
        },
        {
          path: "interactiveData_pre",
          name: "interactiveData_pre",
          component: (resolve) => {
            require(["./views/BI/preview.vue"], resolve);
          },
        },
        //互动用户
        {
          path: "hd_member",
          name: "hd_member",
          component: (resolve) => {
            require(["./views/interactiveMarketing/interactionUser/index.vue"], resolve);
          },
          meta: {
            title: "互动用户"
          }
        },
        {
          path: "hd_activity_decoration",
          name: "hd_activity_decoration",
          component: (resolve) => {
            require(["./views/interactiveMarketing/miniProgramDecoration/index.vue"], resolve);
          },
          meta: {
            title: "小程序装修"
          }
        },
        // 以下为旧路由-不知是否有用
        {
          path: "interactiveActivity",
          redirect: { name: "interactiveSquare" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "interactiveSquare" },
              component: (resolve) => {
                require(["./views/router_page.vue"], resolve);
              },
            },
            {
              path: "interactiveSquare",
              name: "interactiveSquare",
              redirect: { name: "interactiveSquarePage" },
              component: (resolve) => {
                require(["./views/router_page.vue"], resolve);
              },
              children: [
                {
                  path: "",
                  name: "interactiveSquarePage",
                  component: (resolve) => {
                    require(["./views/interactiveMarketing/interactiveSquare.vue"], resolve);
                  },
                },
                {
                  path: "throw", //  投放
                  name: "throw",
                  component: (resolve) => {
                    require(["./views/interactiveMarketing/throw/index.vue"], resolve);
                  },
                },
                {
                  path: "freeTrialEdit",
                  name: "freeTrialEdit",
                  meta: {
                    activeMange: 'freeTrial?activityType=33'
                  },
                  component: (resolve) => {
                    require(["./views/interactiveMarketing/cardManage/points_task_freeTrial.vue"], resolve);
                  },
                },
                { // 活动部件-小
                  path: "activityPartSmall",
                  name: "activityPartSmall",
                  meta: {
                    activeMange: 'activityPartSmall?activityType=56'
                  },
                  component: (resolve) => {
                    require(["./views/interactiveMarketing/cardManage/activity_part_small.vue"], resolve);
                  },
                },
                {
                  path: "memberCardEdit",
                  name: "memberCardEdit",
                  meta: {
                    activeMange: 'memberCard?activityType=32'
                  },
                  component: (resolve) => {
                    require(["./views/interactiveMarketing/cardManage/points_task_memberCard.vue"], resolve);
                  },
                },
                {
                  path: "scratchersEdit",
                  name: "scratchersEdit",
                  meta: {
                    activeMange: 'scratchers?activityType=26'
                  },
                  component: (resolve) => {
                    require(["./views/interactiveMarketing/cardManage/points_task_scratchers.vue"], resolve);
                  },
                },
                {
                  path: "smartPosterEdit",
                  name: "smartPosterEdit",
                  meta: {
                    activeMange: 'smartPoster?activityType=25'
                  },
                  component: (resolve) => {
                    require(["./views/interactiveMarketing/cardManage/points_task_smartPoster.vue"], resolve);
                  },
                },
                {
                  path: "iou", //  投放
                  name: "iou",
                  component: (resolve) => {
                    require(["./views/interactiveMarketing/iou/index.vue"], resolve);
                  },
                },
              ]
            },
            {
              path: "activityManagement",
              name: "activityManagement",
              redirect: { name: "activityManagementPage" },
              component: (resolve) => {
                require(["./views/router_page.vue"], resolve);
              },
              children: [
                {
                  path: "",
                  name: "activityManagementPage",
                  component: (resolve) => {
                    require(["./views/interactiveMarketing/activityManagement.vue"], resolve);
                  },
                },
                {
                  path: "throw", //  投放
                  name: "throw",
                  component: (resolve) => {
                    require(["./views/interactiveMarketing/throw/index.vue"], resolve);
                  },
                },
                {
                  path: "freeTrialEdit",
                  name: "freeTrialEdit",
                  meta: {
                    activeMange: 'freeTrial?activityType=33'
                  },
                  component: (resolve) => {
                    require(["./views/interactiveMarketing/cardManage/points_task_freeTrial.vue"], resolve);
                  },
                },
                {
                  path: "memberCardEdit",
                  name: "memberCardEdit",
                  meta: {
                    activeMange: 'memberCard?activityType=32'
                  },
                  component: (resolve) => {
                    require(["./views/interactiveMarketing/cardManage/points_task_memberCard.vue"], resolve);
                  },
                },
                {
                  path: "scratchersEdit",
                  name: "scratchersEdit",
                  meta: {
                    activeMange: 'scratchers?activityType=26'
                  },
                  component: (resolve) => {
                    require(["./views/interactiveMarketing/cardManage/points_task_scratchers.vue"], resolve);
                  },
                },
                {
                  path: "smartPosterEdit",
                  name: "smartPosterEdit",
                  meta: {
                    activeMange: 'smartPoster?activityType=25'
                  },
                  component: (resolve) => {
                    require(["./views/interactiveMarketing/cardManage/points_task_smartPoster.vue"], resolve);
                  },
                },
                {
                  path: "iou", //  投放
                  name: "iou",
                  component: (resolve) => {
                    require(["./views/interactiveMarketing/iou/index.vue"], resolve);
                  },
                },
              ]
            },
          ],
        },
        {
          path: "unitedPromotionActivity",
          redirect: { name: "eventsList" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: {name:"eventsList"}
            },
            {
              path: "eventsList",
              name: "eventsList",
              component: (resolve) => {
                require(["./views/interactiveMarketing/eventsList.vue"], resolve);
              }
            },
            {
              path: "eventsManage",
              name: "eventsManage",
              component: (resolve) => {
                require(["./views/interactiveMarketing/activityManagementNew.vue"], resolve);
              }
            }
          ]
        },
        {
          path: "interactiveData",
          redirect: { name: "activityData" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "activityData" },
            },
            {
              path: "activityData",
              name: "activityData",
              component: (resolve) => {
                require(["./views/interactiveMarketing/flow_analysis.vue"], resolve);
              },
            },
            {
              path: "prizeStatistics",
              name: "prizeStatistics",
              component: (resolve) => {
                require(["./views/interactiveMarketing/prize_statistics.vue"], resolve);
              },
            },
          ],
        },
        {
          path: "promotionActivity",
          redirect: { name: "suspensionDiagram" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "suspensionDiagram" },
            },
            {
              path: "suspensionDiagram",
              name: "suspensionDiagram",
              component: (resolve) => {
                require(["./views/interactiveMarketing/suspension_diagram1.vue"], resolve);
              },
            },
            {
              path: "otherWayPromotion",
              name: "otherWayPromotion",
              component: (resolve) => {
                require(["./views/interactiveMarketing/otherPromotion/index.vue"], resolve);
              },
            },
            {
              path: "aggregatedLinks",
              name: "aggregatedLinks",
              component: (resolve) => {
               //聚合链接暂时写在这里
                 require(["./views/interactiveMarketing/aggregateLinks/index.vue"], resolve);
              },
            },
          ],
        },
        // {
        //   path: "prizeCenter",
        //   redirect: { name: "couponManagement" },
        //   component: (resolve) => {
        //     require(["./views/router_page1.vue"], resolve);
        //   },
        //   children: [
        //     {
        //       path: "",
        //       redirect: { name: "couponManagement" },
        //     },
        //     {
        //       path: "couponManagement",
        //       name: "couponManagement",
        //       component: (resolve) => {
        //         require(["./views/interactiveMarketing/coupon_management.vue"], resolve);
        //       },
        //     },
        //     {
        //       path: "assetManagement",
        //       name: "assetManagement",
        //       component: (resolve) => {
        //         require(["./views/interactiveMarketing/asset_management.vue"], resolve);
        //       },
        //     },
            // {
            //   path: "goodsManagement",
            //   name: "goodsManagement",
            //   component: (resolve) => {
            //     require(["./views/interactiveMarketing/physical/physical_management.vue"], resolve);
            //   },
            // },
            {
          path: "brandCustomization",
          redirect: { name: "brandCustomize" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "brandCustomize" },
              component: (resolve) => {
                require(["./views/router_page.vue"], resolve);
              },
            },
            {
              path: "brandCustomize",
              name: "brandCustomize",
              redirect: { name: "brandCustomizePage" },
              component: (resolve) => {
                require(["./views/router_page.vue"], resolve);
              },
              children: [
                {
                  path: "",
                  name: "brandCustomizePage",
                  component: (resolve) => {
                    require(["./views/interactiveMarketing/brandCustomize.vue"], resolve);
                  },
                },
                {
                  path: "throw", //  投放
                  name: "throw2",
                  component: (resolve) => {
                    require(["./views/interactiveMarketing/throw/index.vue"], resolve);
                  },
                },
              ]
            },
            {
              path: "cusActivityManagement",
              name: "cusActivityManagement",
              component: (resolve) => {
                require(["./views/interactiveMarketing/cusActivityManagement.vue"], resolve);
              },
            },
            {
              path: "brandAmusingQuestionsItems",
              name: "brandAmusingQuestionsItems",
              component: (resolve) => {
                require(["./views/interactiveMarketing/brandAmusingQuestionsItems.vue"], resolve);
              },
            },
        //   ],
        // },
      ],
    },
      ],
    },
        
    {
      path: '/homePage1',
      name: 'homePage1',
      meta: {
        isOther: true, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      },
      component: (resolve) => {
        require(['./views/homePage/page1.vue'], resolve)
      }
    },
    {
      path: '/homePage2',
      name: 'homePage2',
      meta: {
        isOther: true, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      },
      component: (resolve) => {
        require(['./views/homePage/page2.vue'], resolve)
      }
    },
    {
      path: '/homePage3',
      name: 'homePage3',
      meta: {
        isOther: true, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      },
      component: (resolve) => {
        require(['./views/homePage/page3.vue'], resolve)
      }
    },
    {
      path: '/newHomePage1',
      name: 'newHomePage1',
      meta: {
        isOther: true, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      },
      component: (resolve) => {
        require(['./views/homePage/newPage1.vue'], resolve)
      }
    },
    {
      path: '/newHomePage2',
      name: 'newHomePage2',
      meta: {
        isOther: true, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      },
      component: (resolve) => {
        require(['./views/homePage/newPage2.vue'], resolve)
      }
    },
    {
      path: '/newHomePage3',
      name: 'newHomePage3',
      meta: {
        isOther: true, // 0.商品分析  1.自动化营销pop  2.忠诚度管理自营 3. 忠诚度管理pop
      },
      component: (resolve) => {
        require(['./views/homePage/newPage4.vue'], resolve)
      }
    },
    {
      path: "/agreement_preview",
      name: "agreement_preview",
      component: (resolve) => {
        require(["./views/agreement.vue"], resolve);
      },
    }
    // {
    //   path: "/formTest",
    //   name: "form_test",
    //   component: (resolve) => {
    //     require(["./views/formTest.vue"], resolve);
    //   },
    // },
    // {
    //   path: "/comTest",
    //   name: "com_test",
    //   component: (resolve) => {
    //     require(["./views/comTest.vue"], resolve);
    //   },
    // },
  ],
});
